<template>
    <el-container>
        <el-header>
            <h1>OPPO批搭</h1>
        </el-header>
        <div class="ad-flow">
            <el-steps :active="activeStep" finish-status="success" direction="vertical" align-center>
                <el-step v-for="(item, index) in steps" :key="index" :title="item.name" :description="item.description"
                    :status="getStatus(item.status)">
                    <template #description>
                        <!-- 子步骤 -->
                        <el-steps :active="item.activeChild" direction="vertical" align-center class="custom-steps">
                            <el-step v-for="(child, i) in item.children" :key="i" :title="child.title"
                                :description="child.description" :status="getStatus(child.status)" />
                        </el-steps>
                    </template>
                </el-step>
            </el-steps>
        </div>
        <el-main>
            <div class="plan-container">
                <el-form :model="form" label-position="right" class="demo-ruleForm">
                    <div data-v-da9757c6="" class="adgroup-item">快速搭建</div>

                    <el-form-item label="查询指令:" label-width="160px">
                        <el-button type="primary" v-on:click="templateDialogVisibleChange">历史模板</el-button>
                        <el-button type="primary" @click="dsDialogVisibleChange">管理定时任务</el-button>
                        <el-button type="primary" v-on:click="GetRoChange">刷新</el-button>
                    </el-form-item>



                    <div data-v-da9757c6="" class="adgroup-item">账户信息</div>
                    <el-form-item label="项目名:" label-width="160px">


                        <el-select v-model="btgjc" filterable clearable placeholder="请选择" @change="recordsChange">
                            <el-option v-for="(items, i) in listname" :key="i" :value="items.username">
                            </el-option>
                        </el-select>

                        <!-- <el-button type="primary" v-on:click="GetRoChange">刷新</el-button> -->
                        <el-select v-model="towName" clearable placeholder="请选择" @change="GetRoChange">
                            <el-option v-for="(items, i) in two" :key="i" :value="items.twoname">
                            </el-option>
                        </el-select>
                        <!-- <el-button type="primary" v-on:click="findIds">查询</el-button> -->
                        <!-- <div>项目类目：</div> -->
                        <div class="item-orient">
                            <el-tag v-for="(item, index) in ids_list" :key="index" type="success">
                                {{ item.idsname }}
                            </el-tag>
                        </div>
                    </el-form-item>
                    <div data-v-da9757c6="" class="adgroup-item">广告计划</div>
                    <div data-v-da9757c6="" class="adgroup-item2">计划设置</div>
                    <el-form-item label="推广目标:" label-width="160px">
                        <el-radio-group v-model="form.extension_type" @input="extensionTypeChange">
                            <el-radio-button v-for="item in extensionType_goal_group" :key="item.value"
                                :label="item.value">{{ item.label }}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="竞价策略" label-width="160px">
                        <el-radio-group v-model="form.delivery_mode">
                            <el-radio-button label="0">稳定成本</el-radio-button>
                            <el-radio-button label="1">最大转化</el-radio-button>
                            <el-radio-button label="2">最优成本</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="投放预算(元/天)" label-width="160px">
                        <el-radio-group v-model="form.dayLimit">
                            <el-radio-button label="0">无</el-radio-button>
                            <el-radio-button label="1">预算设置</el-radio-button>
                        </el-radio-group>
                        <el-input v-model="form.dayBudget" placeholder="请输入投放预算" v-if="form.dayLimit == 1">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="计划开关" label-width="160px">
                        <el-radio-group v-model="form.switchPlan">
                            <el-radio-button label="1">关闭</el-radio-button>
                            <el-radio-button label="0">开启</el-radio-button>
                        </el-radio-group>

                    </el-form-item>
                    <el-form-item label="广告计划名称" label-width="160px">
                        <el-input v-model="form.campaign_name" placeholder="请输入广告计划名称"></el-input>
                    </el-form-item>




                    <div data-v-da9757c6="" class="adgroup-item">广告组</div>

                    <div data-v-da9757c6="" class="adgroup-item2">时段</div>
                    <el-form-item label="是否限制推广时段">
                        <!-- 使用el-select来选择是否限制时段 -->
                        <el-select v-model="timeLimit" placeholder="请选择" @change="handleTimeLimitChange">
                            <el-option label="否" :value="0"></el-option>
                            <el-option label="是" :value="1"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 如果选择了限制推广时段，显示统一的时间选择器 -->
                    <div v-if="timeLimit === 1">
                        <el-form-item label="设置推广时间：">
                            <el-row :gutter="20">
                                <el-col :span="12" style="width: 150px">
                                    <el-time-select style="width: 150px" v-model="startTime" :picker-options="pickerOptions"
                                        placeholder="开始时间" @change="validateAndGenerateTimeSet"></el-time-select>
                                </el-col>
                                <el-col :span="12" style="width: 150px">
                                    <el-time-select style="width: 150px" v-model="endTime" :picker-options="pickerOptions"
                                        placeholder="结束时间" @change="validateAndGenerateTimeSet"></el-time-select>
                                </el-col>
                            </el-row>
                            <span v-if="errorMessage" class="error">{{ errorMessage }}</span>
                        </el-form-item>
                    </div>



                    <div data-v-da9757c6="" class="adgroup-item2">流量</div>
                    <el-form-item label="推广流量" prop="extensionFlow" label-width="152px">
                        <el-radio-group v-model="form2.extensionFlow" @input="changeextensionFlow">
                            <el-radio-button label="1" v-if="form.extension_type == 2">全流量场景</el-radio-button>
                            <el-radio-button label="2">自有流量</el-radio-button>
                            <el-radio-button label="3">联盟流量</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="流量场景" prop="flowScene" label-width="152px">
                        <el-radio-group v-model="form2.flowScene" @input="flowScenechange">

                            <el-radio-button v-for="item in form2.flowScene_choose_list" :key="item.value"
                                :label="item.value">{{
                                    item.label }}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>




                    <div data-v-da9757c6="" class="adgroup-item2">目标</div>
                    <el-form-item label="广告类型" prop="dpaProductType" label-width="152px"
                        v-if="form2.flowScene == 6 || form2.flowScene == 7 || form2.flowScene == 9 || form2.flowScene == 10">
                        <el-radio-group v-model="form2.dpaProductType">
                            <el-radio-button label="0">产品化投放</el-radio-button>
                            <!-- <el-radio-button label="1">sdpa</el-radio-button> -->

                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否自动获取落地页url" prop="price" label-width="192px">
                        <el-switch v-model="parsestatus" active-color="#13ce66" inactive-color="#ff4949"
                            @change="parsestatusChang"></el-switch>
                    </el-form-item>
                    <el-form-item label="网页地址类型" prop="pageType" label-width="152px">
                        <el-select v-model="form2.pageTypelabel" filterable :label="form2.pageTypelabel" clearable
                            placeholder="请选择" @change="pageTypechang">
                            <el-option v-for="(items, i) in pageType_list" :key="i" :value="items.value"
                                :label="items.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Deeplink类型" prop="Deeplinktype" label-width="152px"
                        v-if="form.extension_type == 1">
                        <el-radio-group v-model="form2.Deeplinktype">
                            <el-radio-button label="0">应用DP</el-radio-button>
                            <el-radio-button label="3">快应用DP</el-radio-button>
                        </el-radio-group>

                    </el-form-item>
                    <el-form-item label="Deeplink链接启用" prop="linkDeskFlag" label-width="152px"
                        v-if="form2.Deeplinktype == 0 && form.extension_type == 1">
                        <el-switch v-model="form2.Deeplinkstatus" :active-value="1" :inactive-value="0"
                            active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="打开并加桌" prop="linkDeskFlag" label-width="152px"
                        v-if="form2.flowScene == 6 && form.extension_type == 3">
                        <el-switch v-model="form2.linkDeskFlag" :active-value="1" :inactive-value="0" active-color="#13ce66"
                            inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>





                    <div data-v-da9757c6="" class="adgroup-item2">出价</div>
                    <el-form-item label="出价方式" prop="billingType" label-width="152px">
                        <el-radio-group v-model="form2.billingType">
                            <el-radio-button label="2">CPC</el-radio-button>
                            <el-radio-button label="5" v-if="(form2.flowScene != '13')||  (this.form.extension_type==2&&form2.flowScene == '13')">OCPC</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="广告免一阶" prop="defaultSecondStage" label-width="152px" v-if="form2.billingType == 5">
                        <el-switch v-model="form2.defaultSecondStage" :active-value="1" :inactive-value="0"
                            active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>

                    <el-form-item label="是否使用最新广告组出价" prop="price" label-width="192px">
                        <el-switch v-model="isoldgroupprice" active-color="#13ce66" inactive-color="#ff4949"
                            @change="isoldgrouppriceChang"></el-switch>
                    </el-form-item>

                    <el-form-item label="基础出价" prop="price" label-width="152px">
                        <el-input v-model="form2.price" :placeholder="form2.billingType == 2 ? '最低出价0.1元' : '最低出价1.2元'">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>

                    <el-form-item label="转化类型" prop="price" label-width="152px" v-if="form2.billingType == 5">
                        <el-select v-model="form2.ocpcType" filterable placeholder="请选择" @change="ocpcTypechange">
                            <el-option v-for="item in form2.ocpcTypeoptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="转化出价" prop="price" label-width="152px"
                        v-if="form2.billingType == 5 && form2.ocpcType != 47">
                        <el-input v-model="form2.ocpcPrice" placeholder="请输入投放预算">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>

                    <el-form-item label="目标ROI系数" prop="price" label-width="152px" v-if="form2.ocpcType == 47">
                        <el-input v-model="form2.targetROI" placeholder="请输入0.0001到10之间的数字，可精准到小数点后4位">
                        </el-input>
                    </el-form-item>


                    <el-form-item label="深度转化投放" prop="defaultSecondStage" label-width="152px"
                        v-if="form2.billingType == '5' && form.extension_type == '2'">
                        <el-switch v-model="form2.deepOcpcStatus" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>


                    <el-form-item label="深度转化类型" prop="deepOcpcType" label-width="152px"
                        v-if="form2.billingType == '5' && form.extension_type == '2' && form2.deepOcpcStatus">
                        <el-select v-model="form2.deepOcpcType" filterable placeholder="请选择">
                            <el-option v-for="item in form2.deepOcpcTypeoptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="深度转化出价" prop="deepOcpcPrice" label-width="152px"
                        v-if="form2.billingType == '5' && form.extension_type == '2' && form2.deepOcpcStatus">
                        <el-input v-model="form2.deepOcpcPrice" placeholder="请输入投放预算">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>




















                    <div data-v-da9757c6="" class="adgroup-item">创意基础信息</div>


                    <el-form-item label="是否开启混搭" prop="number" label-width="152px">
                        <el-switch v-model="mixminvalue" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>

                    </el-form-item>
                    <el-form-item label="搭建策略" prop="number" label-width="152px">
                        <el-radio-group v-model="mixminvaluelate">
                            <el-radio-button label="重复"></el-radio-button>
                            <el-radio-button label="轮询"></el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="创意搭建数量" prop="number" label-width="152px">
                        <el-input type="number" v-model="form3.number" placeholder="请输入搭建数量" @change="form3Numberchange">

                        </el-input>
                        <!-- <el-button type="primary" plain style="margin-left: 16px;" @click="form3Numberchange">
                            点击
                        </el-button> -->
                    </el-form-item>
                    <el-form-item label="创意样式" prop="type" label-width="152px">
                        <div class="el-form-item__content">
                            <el-select v-model="material_type" disabled>
                            </el-select>

                            <!-- 辅助操作按钮 -->
                            <el-button type="primary" plain style="margin-left: 16px;" @click="openStyleDialog">
                                点击选择
                            </el-button>

                        </div>
                    </el-form-item>

                    <div data-v-da9757c6="" class="adgroup-item2">创意规格</div>


                    <el-form-item label="素材" prop="app_logo" label-width="152px">
                        <el-button type="primary" @click="handleMaterialsdialog">
                            选择素材
                        </el-button>
                    </el-form-item>

                    <el-form-item :label="'按钮文案'" label-width="152px">
                        <el-select v-model="form3.buttonTxt" filterable placeholder="请选择">
                            <el-option v-for="item in buttonTxtOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="品牌名称" prop="brandName" label-width="152px">
                        <el-input v-model="form3.brandName" placeholder="请输入品牌名称">

                        </el-input>
                    </el-form-item>
                    <el-form-item :label="'文案：' + form3.title.length + '个'" label-width="152px">
                        <el-input type="textarea" style="width: 440px;" v-model="titlesString" placeholder="请输入标题（每行一个）"
                            :rows="9" @input="handleInput"></el-input>
                        <div style="display: block;">
                            <div v-for="(line, index) in linesWithLimitError" :key="index"
                                style="color: red; font-size: 12px; margin-top: 5px;">
                                <div>第{{ index + 1 }}行字符限制在0-35个字 {{ line }} </div>
                            </div>

                        </div>
                    </el-form-item>


                </el-form>

            </div>

        </el-main>
        <el-dialog title="选择创意样式" :visible.sync="createTypedialog" width="728px">
            <div class="el-form-item__content">
                <div class="style-selector">
                    <div class="category" v-for="category in styleCategories" :key="category.title">
                        <div class="category-title">{{ category.title }}</div>
                        <ul class="style-list">
                            <li v-for="style in category.styles" :key="style.value" :class="{
                                'selected': selectedStyle === style.value,
                                'recommended': style.recommended
                            }" @click="selectStyle(style)">
                                <!-- <div class="style-image"> -->
                                <img :src="style.image" class="bg-image">
                                <!-- </div> -->
                                <span class="style-info">{{ style.label }}</span>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="createTypedialog = false">取 消</el-button>
                <el-button type="primary" @click="CreativeTypechang">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="上传创意素材" :visible.sync="creativeMaterials" width="1160px" append-to-body>
            <div class="m-header" style="height: 600px;overflow-y: auto;" slot="title">
                <div class="m_header">
                    <el-tabs v-model="activeTab" type="card">
                        <el-tab-pane label="品牌LOGO" name="private">
                            <!-- 私有资源内容 -->
                            <!-- <div>APP_LOGO</div> -->
                            <el-upload ref="upload" :multiple="true" action="#" list-type="picture-card" scoped-slot="text"
                                :file-list="txfileList" :on-change="txhandleFileChange" :on-success="txhandleUploadSuccess"
                                :rows="1" :auto-upload="false">

                                <!-- 自定义触发按钮 -->
                                <div slot="trigger" class="upload-trigger">
                                    <el-tag>选择头像素材</el-tag>
                                </div>

                                <!-- 自定义文件列表项 -->
                                <template slot="file" slot-scope="{ file }">
                                    <div class="file-item">
                                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-preview"
                                                @click.stop="handlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span class="el-upload-list__item-delete" @click.stop="handleRemove(file)">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </template>
                            </el-upload>


                        </el-tab-pane>
                        <el-tab-pane label="图片" name="img">
                            <!-- 公共资源内容 -->
                            <!-- <div>图片数量: {{ tpfileList.length }}</div> -->
                            <div class="image-header">
                                <div class="image-count">
                                    <i class="el-icon-picture"></i>
                                    图片数量: {{ tpfileList.length }}
                                </div>
                                <el-button v-if="tpfileList.length > 0" size="mini" type="danger" icon="el-icon-delete"
                                    @click="clearAllImages" class="clear-all-btn">
                                    清空全部
                                </el-button>
                            </div>
                            <el-upload ref="upload" :multiple="true" action="#" list-type="picture-card" scoped-slot="text"
                                :file-list="tpfileList" :on-change="tphandleFileChange" :on-success="tphandleUploadSuccess"
                                :rows="1" :auto-upload="false">

                                <!-- 自定义触发按钮 -->
                                <div slot="trigger" class="upload-trigger">
                                    <el-tag>选择图片素材</el-tag>
                                </div>

                                <!-- 自定义文件列表项 -->
                                <template slot="file" slot-scope="{ file }">
                                    <div class="file-item">
                                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-preview"
                                                @click.stop="tphandlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span class="el-upload-list__item-delete" @click.stop="tphandleRemove(file)">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </template>
                            </el-upload>
                        </el-tab-pane>
                        <el-tab-pane label="视频封面" name="imgvideo">
                            <!-- 公共资源内容 -->
                            <!-- <div>图片数量: {{ videotpfileList.length }}</div> -->
                            <div class="image-header">
                                <div class="image-count">
                                    <i class="el-icon-picture"></i>
                                    封面图片数量: {{ videotpfileList.length }}
                                </div>
                                <el-button v-if="videotpfileList.length > 0" size="mini" type="danger" icon="el-icon-delete"
                                    @click="clearAllcoverImages" class="clear-all-btn">
                                    清空全部
                                </el-button>

                            </div>
                            <el-upload ref="upload" :multiple="true" action="#" list-type="picture-card" scoped-slot="text"
                                :file-list="videotpfileList" :on-change="videotphandleFileChange"
                                :on-success="tphandleUploadSuccess" :rows="1" :auto-upload="false">

                                <!-- 自定义触发按钮 -->
                                <div slot="trigger" class="upload-trigger">
                                    <el-tag>选择图片素材</el-tag>
                                </div>

                                <!-- 自定义文件列表项 -->
                                <template slot="file" slot-scope="{ file }">
                                    <div class="file-item">
                                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-preview"
                                                @click.stop="videotphandlePictureCardPreview(file)">
                                                <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span class="el-upload-list__item-delete"
                                                @click.stop="videotphandleRemove(file)">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </span>
                                    </div>
                                </template>
                            </el-upload>
                        </el-tab-pane>
                        <el-tab-pane label="视频" name="video">
                            <!-- 公共资源内容 -->
                            <!-- <div>视频数量:{{ videofileList.length }}</div> -->
                            <div class="image-header">
                                <div class="image-count">
                                    <i class="el-icon-picture"></i>
                                    视频数量: {{ videofileList.length }}
                                </div>
                                <el-button v-if="videofileList.length > 0" size="mini" type="danger" icon="el-icon-delete"
                                    @click="clearAllvideos" class="clear-all-btn">
                                    清空全部
                                </el-button>
                                <div class="auto-cover-option">
                                    <el-checkbox v-model="autoGenerateCover" @change="handleAutoCoverChange">
                                        自动生成视频封面
                                    </el-checkbox>
                                    <el-tooltip content="开启后上传视频时会自动提取第一帧作为封面" placement="top">
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </div>
                            </div>
                            <el-upload class="upload-wrapper" drag action="#" :auto-upload="false" :multiple="true"
                                ref="upload" :file-list="videofileList" :on-change="videohandleFileChange"
                                :show-file-list="false">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">
                                    将文件拖到此处，或<em>点击上传</em>
                                </div>
                                <div class="el-upload__tip" slot="tip">
                                    支持 MP4 格式
                                </div>


                            </el-upload>
                            <div class="video-list">
                                <div class="video-item" v-for="(file, index) in videofileList"
                                    :key="file.uid || file.name || index">
                                    <div class="video-content">
                                        <span class="video-title">{{ file.name }}</span>
                                        <div class="video-thumbnail">
                                            <video :src="file.url" controls></video>
                                        </div>
                                        <el-button type="text" icon="el-icon-delete" @click="handleRemove2(file)"
                                            class="delete-btn"></el-button>
                                    </div>
                                </div>
                            </div>

                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>


        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="20%" :src="dialogImageUrl" alt="">
        </el-dialog>

        <el-dialog title="模板管理" :visible.sync="templateDialogVisible" width="70%" @close="handleDialogClose">
            <el-form :inline="true" :model="queryParams" class="query-form">
                <el-form-item label="模板名称">
                    <el-input v-model="queryParams.templateName" placeholder="请输入模板名称" clearable
                        @keyup.enter.native="handleQuery"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="handletemplateQuery">查询</el-button>
                    <el-button @click="resettemplateQuery">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="templateList" border stripe style="width: 100%" ref="templateTable">

                <el-table-column prop="model_name" label="模板名称"></el-table-column>

                <!-- <el-table-column prop="createdAt" label="创建时间" width="180">
                    <template slot-scope="scope">
                        {{ formatTimestamp(scope.row.createdAt) }}
                    </template>
                </el-table-column> -->

                <el-table-column label="操作" width="200" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="handletemplateDelete(scope.row)">删除</el-button>
                        <el-button size="mini" type="success" @click="templateInfoChange(scope.row)">选中录入</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handletamplateCurrentChange"
                :current-page="queryParams.page_no" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.page_size"
                layout="total, sizes, prev, pager, next, jumper" :total="templatetotal" class="pagination"></el-pagination>


            <div slot="footer" class="dialog-footer">
                <el-button @click="templateDialogVisible = false">取消</el-button>
                <!-- <el-button type="primary" @click="handletemplateConfirm" :disabled="!selectedTemplate">确认选择</el-button> -->
            </div>


        </el-dialog>



        <el-dialog title="设置定时计划" :visible.sync="timerDialogVisible" width="500px" center v-if="timerDialogVisible"
            @close="handleTimerCancel">
            <el-form :model="timerForm" label-width="80px" ref="timerFormRef">
                <el-form-item label="计划名称">
                    <el-input v-model="timerForm.name" placeholder="请输入定时计划名称" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="执行时间">
                    <el-date-picker v-model="timerForm.time" type="datetime" placeholder="选择执行时间"
                        value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" :picker-options="timerPickerOptions">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleTimerCancel">取 消</el-button>
                <el-button type="primary" @click="handleTimerConfirm">确 定</el-button>
            </span>
        </el-dialog>



        <el-dialog title="定时任务管理" :visible.sync="dsDialogVisible" width="70%" @close="handleDialogClose">
            <el-form :inline="true" :model="dsqueryParams" class="query-form">
                <el-form-item label="定时任务名称">
                    <el-input v-model="dsqueryParams.taskName" placeholder="请输入模板名称" clearable
                        @keyup.enter.native="handleQuery"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="dshandletemplateQuery">查询</el-button>
                    <!-- <el-button @click="dsresettemplateQuery">重置</el-button> -->
                </el-form-item>
            </el-form>
            <el-table :data="dstemplateList" border stripe style="width: 100%">
                <el-table-column prop="id" label="定时任务"></el-table-column>
                <el-table-column prop="taskName" label="定时任务"></el-table-column>

                <el-table-column prop="createdAt" label="创建时间" width="180">
                    <template slot-scope="scope">
                        <!-- {{ formatTimestamp(scope.row.executeTime) }}-->
                        {{ scope.row.executeTime }}
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="任务状态" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 0">待执行</span>
                        <span v-else-if="scope.row.status === 1">执行中</span>
                        <span v-else-if="scope.row.status === 2">成功</span>
                        <span v-else-if="scope.row.status === 3">失败</span>
                        <span v-else>未知</span>
                    </template>
                </el-table-column>

                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="dshandletemplateDelete(scope.row)">删除</el-button>
                        <el-button size="mini" type="success" @click="templatedsChange(scope.row)">编辑</el-button>
                        <el-button size="mini" type="success" @click="templatedslogChange(scope.row)">查看日志</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handledsSizeChange" @current-change="handledstamplateCurrentChange"
                :current-page="queryParams.current" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="dstemplatetotal"
                class="pagination"></el-pagination>


            <div slot="footer" class="dialog-footer">
                <el-button @click="dsDialogVisible = false">取消</el-button>
                <!-- <el-button type="primary" @click="handletemplateConfirm" :disabled="!selectedTemplate">确认选择</el-button> -->
            </div>







        </el-dialog>


        <el-dialog title="编辑定时任务" :visible.sync="dschangeDialogVisible" width="500px" center
            @close="dschangeHandleDialogClose">
            <el-form :model="dschangeForm" :rules="dschangeRules" ref="dschangeFormRef" label-width="80px">

                <el-form-item label="任务名称" prop="dschangeTaskName">
                    <el-input v-model="dschangeForm.dschangeTaskName" placeholder="请输入任务名称" clearable maxlength="50"
                        show-word-limit>
                    </el-input>
                </el-form-item>

                <el-form-item label="执行时间" prop="dschangeExecuteTime">
                    <el-date-picker v-model="dschangeForm.dschangeExecuteTime" type="datetime" placeholder="选择执行时间"
                        value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" :picker-options="dschangePickerOptions"
                        style="width: 100%">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="当前状态">
                    <el-tag effect="plain">
                        <!-- {{ dschangeForm.dschangeStatus }} -->
                        <!-- <template slot-scope="scope"> -->
                        <span v-if="dschangeForm.dschangeStatus === 0">待执行</span>
                        <span v-else-if="dschangeForm.dschangeStatus === 1">执行中</span>
                        <span v-else-if="dschangeForm.dschangeStatus === 2">成功</span>
                        <span v-else-if="dschangeForm.dschangeStatus === 3">失败</span>
                        <span v-else>未知</span>
                        <!-- </template> -->
                    </el-tag>
                </el-form-item>

            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dschangeDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dschangeHandleSubmit" :loading="dschangeLoading">
                    确 定
                </el-button>
            </span>
        </el-dialog>



        <div class="adgroup-footer">

            <el-button type="primary" @click="templateSave">
                保存模板
            </el-button>
            <el-button type="primary" @click="createdanyuan" :loading="isLoading">

                {{ isLoading ? '处理中...' : '开始搭建' }}
            </el-button>

            <el-button type="primary" @click="createdsdanyuan" :loading="isdsLoading">
                {{ isdsLoading ? '处理中...' : '创建定时搭建' }}
            </el-button>

            <div style="width: 300px;margin-left: 40px;" v-if="showProgress">
                <el-progress :percentage="uploadPercent" :text-inside="false" :color="customColors" :stroke-width="4"
                    style="" />
            </div>

        </div>
        <el-dialog title="执行日志详情" :visible.sync="dslogDialogVisible" width="900px" top="5vh" @close="dslogHandleClose">

            <!-- 加载状态 -->
            <div v-if="dslogLoading" style="text-align: center; padding: 40px;">
                <el-icon class="is-loading" style="font-size: 24px;">
                    <Loading />
                </el-icon>
                <p style="margin-top: 16px; color: #909399;">日志加载中...</p>
            </div>

            <!-- 日志表格 -->
            <div v-else>
                <el-table :data="dslogCurrentData" border stripe style="width: 100%" empty-text="暂无日志数据">
                    <el-table-column prop="idsname" label="账户" width="120" :formatter="formatAccountName">
                    </el-table-column>

                    <el-table-column label="计划" width="200">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.planMsg || '等待执行'" placement="top"
                                :disabled="!scope.row.planMsg || scope.row.planMsg.length <= 60">
                                <div :class="getStatusClass(scope.row.planMsg)" class="message-content multi-line-ellipsis">
                                    {{ scope.row.planMsg || '等待执行' }}
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>

                    <el-table-column label="广告组" width="200">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.groupMsg || '等待执行'" placement="top"
                                :disabled="!scope.row.groupMsg || scope.row.groupMsg.length <= 60">
                                <div :class="getStatusClass(scope.row.groupMsg)"
                                    class="message-content multi-line-ellipsis">
                                    {{ scope.row.groupMsg || '等待执行' }}
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>

                    <el-table-column label="创意" width="200">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.createMsg || '等待执行'" placement="top"
                                :disabled="!scope.row.createMsg || scope.row.createMsg.length <= 60">
                                <div :class="getStatusClass(scope.row.createMsg)"
                                    class="message-content multi-line-ellipsis">
                                    {{ scope.row.createMsg || '等待执行' }}
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>

                    <el-table-column label="总体状态" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="getOverallStatusType(scope.row)" effect="plain" size="medium">
                                {{ getOverallStatus(scope.row) }}
                            </el-tag>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 统计信息 -->
                <div style="margin-top: 15px; padding: 10px; background: #f5f7fa; border-radius: 4px; text-align: center;">
                    <span>总计: {{ dslogCurrentData.length }} 个账户 | </span>
                    <span style="color: #67c23a;">成功: {{ getSuccessCount() }} | </span>
                    <span style="color: #f56c6c;">失败: {{ getErrorCount() }}</span>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dslogDialogVisible = false">关 闭</el-button>
                <el-button type="primary" @click="dslogExportLog" v-if="dslogCurrentData.length > 0">导出日志</el-button>
            </span>
        </el-dialog>
    </el-container>
</template>

<script>
import axios from "axios";
import dayjs from 'dayjs';
import sha1 from 'js-sha1';
import { Base64 } from 'js-base64';
import qs from 'qs';
export default {
    data() {
        return {
            autoGenerateCover: true,
            dslogDialogVisible: false,
            dslogLoading: false,
            dslogCurrentData: [], // 所有账户的日志数据
            dschangeDialogVisible: false,
            dschangeLoading: false,
            dschangeCurrentId: null,
            dschangeCurrentStatus: 0,
            dschangeForm: {
                dschangeTaskName: '',
                dschangeExecuteTime: '',
                dschangeStatus: 0
            },
            dschangeRules: {
                dschangeTaskName: [
                    { required: true, message: '请输入任务名称', trigger: 'blur' },
                    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                ],
                dschangeExecuteTime: [
                    { required: true, message: '请选择执行时间', trigger: 'change' }
                ]
            },
            dschangePickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                },
                shortcuts: [{
                    text: '1小时后',
                    onClick(picker) {
                        const date = new Date();
                        date.setHours(date.getHours() + 1);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '明天此时',
                    onClick(picker) {
                        const date = new Date();
                        date.setDate(date.getDate() + 1);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '3天后',
                    onClick(picker) {
                        const date = new Date();
                        date.setDate(date.getDate() + 3);
                        picker.$emit('pick', date);
                    }
                }]
            },




            dingshiobj: {
                ids_list: [],
                timerName: "",
                executeTime: "",
                data1: {},
                data2: {},
                data3: [],
            },
            countdown: 0,
            countdownTimer: null,
            isLoading: false,
            listname: [],
            customColors: [
                { color: '#f56c6c', percentage: 20 },
                { color: '#e6a23c', percentage: 40 },
                { color: '#5cb87a', percentage: 60 },
                { color: '#1989fa', percentage: 80 },
                { color: '#6f7ad3', percentage: 100 }
            ],
            showProgress: false,
            uploadPercent: 0,
            records: [],
            dingxiangbao: [],
            ids_list: [],
            selectedValue: [],
            selectedValue2: [],
            options: [], // 初始化空数组
            cascaderProps: {
                value: 'value',
                label: 'label',
                children: 'children',
                checkStrictly: false, // 如果需要严格模式
                multiple: true,
                emitPath: false
            },
            audience_list: [],
            btgjc: "",
            form: {
                extension_type: 1,       // 默认选中应用推广
                delivery_mode: 0,  // 营销场景
                dayLimit: 0,
                planName: '',              // 广告计划名称
                dayBudget: '',            // 投放预算
                switchPlan: 1,
                campaign_name: ''
            },

            extensionType_goal_group: [
                { value: 1, label: "网页推广" },
                { value: 2, label: "应用推广-应用下载" },
                { value: 6, label: "应用推广-应用调起" },
                { value: 3, label: "快应用推广" },
                { value: 7, label: "小程序推广" },
            ],
            ocpcTypeoptions: [
                { value: "14", label: "deeplink拉活", index: 1 },
                { value: "16", label: "deeplink回传激活", index: 1 },
                { value: "17", label: "deeplink回传注册", index: 1 },
                { value: "18", label: "deeplink应用付费", index: 1 },
                { value: "21", label: "deeplink应用内下单", index: 1 },
                { value: "6", label: "线索提交", index: 1 },

                { value: "2", label: "激活", index: 2 },
                { value: "7", label: "注册", index: 2 },
                { value: "9", label: "应用付费", index: 2 },
                { value: "8", label: "回传激活", index: 2 },


                { value: "22", label: "快应用/小程序付费", index: 3 },
                { value: "32", label: "快应用关键行为", index: 3 },
                { value: "47", label: "快应用变现ROI1", index: 3 },
                { value: "51", label: "快游戏付费ROI1", index: 3 },
            ],
            
            form2: {
                deepOcpcTypeoptions:[],
                Deeplinkstatus: 0,
                linkDeskFlag: 1,
                extensionFlow: '2',
                flowScene: 13,
                pageTypelabel: "",
                targetROI: "",
                flowScene_list: [
                    // {
                    //     value: "1",
                    //     list: [{ value: "1", label: "全流量场景" },]
                    // },
                    {
                        value: "2",
                        list: [{ value: "13", label: "展示优选" },
                        { value: "6", label: "信息流" },]//1
                    }, {
                        value: "3",
                        list: [{ value: "12", label: "联盟通投" },
                        { value: "7", label: "Banner" },//1
                        { value: "8", label: "开屏" },//1
                        { value: "9", label: "插屏" },//1
                        { value: "10", label: "原生" },//1
                        { value: "11", label: "激励视频" },]
                    }
                ],
                pageType: '',



                flowScene_choose_list: [],
                dpaProductType: '0',
                Deeplinktype: 0,
                beginTime: [],
                billingType: '2',
                price: null,
                defaultSecondStage: 1,
                ocpcType: null,
                ocpcPrice: null,
                ocpcTypeoptions: [],

                deepOcpcType: null,
                deepOcpcPrice: 0,

                deepOcpcStatus: false,

                plan: '',
                adgroup_name: '',

            },
            pageType_list: [
                { value: "0", label: "自定义落地页" },//1
                { value: "4", label: "萤火虫建站" },//1
                { value: "7", label: "API线索投放" },//1
                { value: "6", label: "JS线索投放" },
                { value: "9", label: "应用落地页" }
            ],
            isSelecting: false,
            selectionStart: null,
            material_type: "",
            titlesString: '',
            titlesString2: '',

            form3: {

                buttonTxt: "",
                brandName: "",
                title: [],
                number: ''
            },
            buttonTxtOptions: [

                {
                    value: '打开',
                    label: '打开'
                }, {
                    value: '下载',
                    label: '下载'
                }, {
                    value: '去看看',
                    label: '去看看'
                }, {
                    value: '了解详情',
                    label: '了解详情'
                }, {
                    value: '参与活动',
                    label: '参与活动'
                }, {
                    value: '领取优惠',
                    label: '领取优惠'
                }, {
                    value: '立即打开',
                    label: '立即打开'
                }, {
                    value: '立即下载',
                    label: '立即下载'
                }, {
                    value: '立即查看',
                    label: '立即查看'
                }, {
                    value: '立即体验',
                    label: '立即体验'
                }, {
                    value: '立即申请',
                    label: '立即申请'
                }, {
                    value: '获取报价',
                    label: '获取报价'
                }, {
                    value: '立即领取',
                    label: '立即领取'
                }, {
                    value: '点击咨询',
                    label: '点击咨询'
                }, {
                    value: '下载抢购',
                    label: '下载抢购'
                }
            ],
            creativeMaterials: false, //素材
            txfileList: [],
            txfileCode: [],
            dialogImageUrl: '',
            activeTab: 'private',
            txuploadDialogVisible: false,
            txList: [],
            txuploading: false,
            dialogVisible: false,
            tpfileList: [],
            tpfileListcode: [],
            videotpfileListcode: [],
            videotpfileList: [],
            tpuploadDialogVisible: false,
            videofileList: [],
            selectedStyle: 'reward_video_vertical',
            styleCategories: [
                {
                    title: '视频类',
                    styles: [
                        {
                            value: '63',
                            label: '竖版视频',
                            image: 'https://demo.nbweiou.cn/img/01.png', // truncated for brevity
                            recommended: true
                        },
                        {
                            value: '60',
                            label: '横版视频',
                            image: 'https://demo.nbweiou.cn/img/02.png'
                        },
                    ]
                },
                {
                    title: '图文类',
                    styles: [
                        {
                            value: '20',
                            label: '横版小图',
                            image: 'https://demo.nbweiou.cn/img/05.png'
                        },
                        {
                            value: '1',
                            label: '横版大图',
                            image: 'https://demo.nbweiou.cn/img/06.png'
                        },
                        {
                            value: ' 50',
                            label: '竖版大图',
                            image: 'https://demo.nbweiou.cn/img/06.png'
                        },
                        {
                            value: '30',
                            label: '横版组图',
                            image: 'https://demo.nbweiou.cn/img/07.png'
                        },
                        {
                            value: '71',
                            label: '图标大图',
                            image: 'https://demo.nbweiou.cn/img/09.png'
                        },
                        {
                            value: '5',
                            label: '开屏横图',
                            image: 'https://demo.nbweiou.cn/img/10.png'
                        },
                        {
                            value: '34',
                            label: '开屏竖图',
                            image: 'https://demo.nbweiou.cn/img/10.png'
                        }




                    ]
                }
            ],
            styleCategorieslist: [
                {
                    name: "默认",
                    value: 0,
                    list: [
                        {
                            title: '视频类',
                            styles: [
                                {
                                    value: '63',
                                    label: '竖版视频',
                                    image: 'https://demo.nbweiou.cn/img/01.png', // truncated for brevity
                                    recommended: true
                                },
                                {
                                    value: '60',
                                    label: '横版视频',
                                    image: 'https://demo.nbweiou.cn/img/02.png'
                                },
                            ]
                        },
                        {
                            title: '图文类',
                            styles: [
                                {
                                    value: '20',
                                    label: '横版小图',
                                    image: 'https://demo.nbweiou.cn/img/05.png'
                                },
                                {
                                    value: '1',
                                    label: '横版大图',
                                    image: 'https://demo.nbweiou.cn/img/06.png'
                                },
                                {
                                    value: ' 50',
                                    label: '竖版大图',
                                    image: 'https://demo.nbweiou.cn/img/06.png'
                                },
                                {
                                    value: '30',
                                    label: '横版组图',
                                    image: 'https://demo.nbweiou.cn/img/07.png'
                                },
                                {
                                    value: '71',
                                    label: '图标大图',
                                    image: 'https://demo.nbweiou.cn/img/09.png'
                                },


                            ]
                        }
                    ]
                },
                {
                    name: "开屏",
                    value: 8,
                    list: [{
                        title: '视频类',
                        styles: [
                            {
                                value: '63',
                                label: '竖版视频',
                                image: 'https://demo.nbweiou.cn/img/01.png', // truncated for brevity
                                recommended: true
                            },
                            {
                                value: '60',
                                label: '横版视频',
                                image: 'https://demo.nbweiou.cn/img/02.png'
                            },
                        ]
                    },
                    {
                        title: '图文类',
                        styles: [
                            {
                                value: '5',
                                label: '开屏横图',
                                image: 'https://demo.nbweiou.cn/img/05.png'
                            },
                            {
                                value: '34',
                                label: '开屏竖图',
                                image: 'https://demo.nbweiou.cn/img/06.png'
                            },
                            {
                                value: '71',
                                label: '图标大图',
                                image: 'https://demo.nbweiou.cn/img/09.png'
                            },


                        ]
                    }]
                },
                {
                    name: "原生",
                    value: 10,
                    list: [{
                        title: '视频类',
                        styles: [
                            {
                                value: '63',
                                label: '竖版视频',
                                image: 'https://demo.nbweiou.cn/img/01.png', // truncated for brevity
                                recommended: true
                            },
                            {
                                value: '60',
                                label: '横版视频',
                                image: 'https://demo.nbweiou.cn/img/02.png'
                            },
                        ]
                    },
                    {
                        title: '图文类',
                        styles: [
                            {
                                value: '20',
                                label: '横版小图',
                                image: 'https://demo.nbweiou.cn/img/05.png'
                            },
                            {
                                value: '1',
                                label: '横版大图',
                                image: 'https://demo.nbweiou.cn/img/06.png'
                            },
                            {
                                value: ' 50',
                                label: '竖版大图',
                                image: 'https://demo.nbweiou.cn/img/06.png'
                            },
                            {
                                value: '30',
                                label: '横版组图',
                                image: 'https://demo.nbweiou.cn/img/07.png'
                            },
                            {
                                value: '71',
                                label: '图标大图',
                                image: 'https://demo.nbweiou.cn/img/09.png'
                            },


                        ]
                    }]
                }, {
                    name: "信息流",
                    value: 6,
                    list: [{
                        title: '视频类',
                        styles: [
                            {
                                value: '63',
                                label: '竖版视频',
                                image: 'https://demo.nbweiou.cn/img/01.png', // truncated for brevity
                                recommended: true
                            },
                            {
                                value: '60',
                                label: '横版视频',
                                image: 'https://demo.nbweiou.cn/img/02.png'
                            },
                        ]
                    },
                    {
                        title: '图文类',
                        styles: [
                            {
                                value: '20',
                                label: '横版小图',
                                image: 'https://demo.nbweiou.cn/img/05.png'
                            },
                            {
                                value: '1',
                                label: '横版大图',
                                image: 'https://demo.nbweiou.cn/img/06.png'
                            },
                            {
                                value: ' 50',
                                label: '竖版大图',
                                image: 'https://demo.nbweiou.cn/img/06.png'
                            },
                            {
                                value: '30',
                                label: '横版组图',
                                image: 'https://demo.nbweiou.cn/img/07.png'
                            },
                        ]
                    }]
                },
                {
                    name: "不限",
                    value: 12,
                    list: [
                        {
                            title: '视频类',
                            styles: [
                                {
                                    value: '63',
                                    label: '竖版视频',
                                    image: 'https://demo.nbweiou.cn/img/01.png', // truncated for brevity
                                    recommended: true
                                },
                                {
                                    value: '60',
                                    label: '横版视频',
                                    image: 'https://demo.nbweiou.cn/img/02.png'
                                },
                            ]
                        },
                        {
                            title: '图文类',
                            styles: [
                                {
                                    value: '20',
                                    label: '横版小图',
                                    image: 'https://demo.nbweiou.cn/img/05.png'
                                },
                                {
                                    value: '1',
                                    label: '横版大图',
                                    image: 'https://demo.nbweiou.cn/img/06.png'
                                },
                                {
                                    value: ' 50',
                                    label: '竖版大图',
                                    image: 'https://demo.nbweiou.cn/img/06.png'
                                },
                                {
                                    value: '30',
                                    label: '横版组图',
                                    image: 'https://demo.nbweiou.cn/img/07.png'
                                },
                                {
                                    value: '71',
                                    label: '图标大图',
                                    image: 'https://demo.nbweiou.cn/img/09.png'
                                },
                                {
                                    value: '5',
                                    label: '开屏横图',
                                    image: 'https://demo.nbweiou.cn/img/10.png'
                                },
                                {
                                    value: '34',
                                    label: '开屏竖图',
                                    image: 'https://demo.nbweiou.cn/img/10.png'
                                }




                            ]
                        }
                    ]
                },

            ],

            checkAll: true,
            isIndeterminate: false,
            adSlotisIndeterminate: false,
            adSlotcheckAll: true,
            createTypedialog: false,
            selectedStylelabel: "",
            allRestaurants: [],
            linesWithLimitError: [],
            linesWithLimitError2: [],
            startDate: '',
            endDate: '',
            campaign_id: '',
            videofileListcode: [],
            userId: '',
            two: '',
            towName: '',


            timeLimit: 1, // 默认不限制时段
            startTime: null, // 推广的开始时间
            endTime: null,   // 推广的结束时间
            errorMessage: '', // 错误信息提示
            timeSet: '', // 最终生成的 timeSet JSON 字符串
            pickerOptions: {
                start: '00:00',
                step: '00:30',
                end: '24:00'
            },
            days: ["1", "2", "3", "4", "5", "6", "7"],


            activeStep: 0,
            steps: [
                {
                    name: '广告计划', status: 'wait',
                },
                { name: '广告组', status: 'wait' },
                { name: '广告创意', status: 'wait' },

            ],
            currentStep: 0,
            currentIndeximg: 0,
            currentIndexvideo: 0,
            currentIndextext: 0,
            images: ["测试1", "测试2"],
            materialType: '',
            mixminvalue: false,
            mixminvaluelate: '轮询',
            isoldgroupprice: false,
            parsestatus: false,
            templateDialogVisible: false,
            dsDialogVisible: false,
            templateList: [],
            templatetotal: 0,
            queryParams: {
                model_name: '',
                page_no: 1,
                page_size: 10
            },
            dstemplateList: [],
            dstemplatetotal: 0,
            dsqueryParams: {
                taskName: '',
                current: 1,
                size: 10
            },

            timerDialogVisible: false,
            timerForm: {
                name: '',
                time: ''
            },
            timerResolve: null,
            timerPickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7; // 禁用今天之前的时间
                }
            },
            isdsLoading: false,
            lastClickTime: 0,

        };
    },
    created() {
        axios.get('https://test.nbweiou.cn/api/oppo/find_list_name', {
        }).then(
            res => {
                this.listname = res.data
                console.log(this.listname)
            }
        )
        this.extensionTypeChange(this.form.extension_type)
        this.changeextensionFlow(2)
        // this.userId = this.$route.query.userId

        // if (!this.userId) {
        //     // 使用Element UI的消息提示
        //     this.$message.warning('您得先登录')

        //     // 设置延迟跳转让用户看到提示
        //     setTimeout(() => {
        //         // 重定向到登录页面（外部链接）
        //         window.location.href = 'https://control.zjwec.cn/page/end/login.html'
        //     }, 1500)  // 1.5秒后跳转

        //     // 终止后续执行
        // }
        // // else {
        // //     // 如果获取到userId则正常加载
        // //     this.loadTemplates(1)
        // // }

        // this.handlelistByUbs()
        // this.getdingxiangbao()
        // this.updateCheckAllState
        // this.allRestaurants = this.restaurants.map(item => {
        //     return { value: item }
        // })

        // const apiData = {
        //     "audience_list": [this.audience_list], // 你的原始数据
        //     "category_id": 25,
        //     "category_name": "dmp推荐人群",
        //     "type": 3
        // };

        // // 转换数据结构

    },
    watch: {
        // 监听选中项变化

    },

    methods: {
        handleAutoCoverChange(value) {
            console.log(value);
            this.autoGenerateCover = value
        },
        templatedslogChange(row) {
            console.log('查看日志:', row);

            this.dslogLoading = true;
            this.dslogDialogVisible = true;

            // 调用真实API获取日志数据
            this.dslogFetchLogData(row.id).then(logData => {
                this.dslogCurrentData = Array.isArray(logData) ? logData : [logData];
                console.log('日志数据:', this.dslogCurrentData);
            }).catch(error => {
                console.error('获取日志失败:', error);
                this.$message.error('获取日志失败: ' + (error.message || '请检查网络连接'));
            }).finally(() => {
                this.dslogLoading = false;
            });
        },

        /**
         * 获取日志数据（真实API调用）
         */
        async dslogFetchLogData(taskId) {
            try {
                const response = await axios.get('https://control.zjwec.cn/api/v1/oppo/pd/task/log', {
                    params: {
                        id: String(taskId)
                    }
                });

                console.log('日志API响应:', response.data);

                // 根据实际API返回结构调整
                if (response.data && response.data.code == 200) {
                    return response.data.data || response.data;
                } else if (response.data && response.data.success) {
                    return response.data.data || response.data;
                } else {
                    return response.data;
                }
            } catch (error) {
                console.error('API调用失败:', error);

                if (error.response) {
                    throw new Error(`服务器错误: ${error.response.status} - ${error.response.data.message || '请求失败'}`);
                } else if (error.request) {
                    throw new Error('网络连接失败，请检查网络设置');
                } else {
                    throw new Error('请求配置错误: ' + error.message);
                }
            }
        },

        /**
         * 格式化账户名称
         */
        formatAccountName(row) {
            return row.idsname || `账户${this.dslogCurrentData.indexOf(row) + 1}`;
        },

        /**
         * 获取状态样式类
         */
        getStatusClass(message) {
            if (!message) return 'status-wait';
            if (message.includes('成功')) return 'status-success';
            if (message.includes('失败') || message.includes('错误') || message.includes('沉默广告主')) return 'status-error';
            return 'status-wait';
        },

        /**
         * 获取状态文本
         */
        getStatusText(message) {
            if (!message) return '等待执行';
            if (message.includes('成功')) return '成功';
            if (message.includes('失败') || message.includes('错误') || message.includes('沉默广告主')) return '失败';
            return '执行中';
        },

        /**
         * 获取失败原因
         */
        getReasonText(message) {
            if (!message) return '';
            if (message.includes('成功')) return '';

            // 提取失败原因
            if (message.includes('沉默广告主')) {
                return '沉默广告主';
            }
            if (message.includes('失败')) {
                return message.replace('失败', '').trim();
            }
            if (message.includes('错误')) {
                return message.replace('错误', '').trim();
            }
            return message;
        },

        /**
         * 获取总体状态
         */
        getOverallStatus(row) {
            console.log(row.createMsg == '' && row.planMsg == '' && row.groupMsg == '');
            if (row.createMsg && row.createMsg.includes('成功')) {
                return '成功';
            } else if (row.createMsg == null && row.planMsg == null && row.groupMsg == null) {
                return '待执行';
            } else {
                return '失败';
            }
        },

        /**
         * 获取总体状态类型
         */
        getOverallStatusType(row) {
            if (row.createMsg && row.createMsg.includes('成功')) {
                return 'success';
            } else if (row.createMsg == null && row.planMsg == null && row.groupMsg == null) {
                return 'warning';
            } else {
                return 'danger';
            }
        },

        /**
         * 获取成功账户数量
         */
        getSuccessCount() {
            return this.dslogCurrentData.filter(row =>
                row.createMsg && row.createMsg.includes('成功')
            ).length;
        },

        /**
         * 获取失败账户数量
         */
        getErrorCount() {
            return this.dslogCurrentData.filter(row =>
                !(row.createMsg && row.createMsg.includes('成功'))
            ).length;
        },

        /**
         * 导出日志
         */
        dslogExportLog() {
            const logContent = this.dslogGenerateLogContent();
            this.dslogDownloadLogFile(logContent, `任务日志_${this.dslogCurrentData[0].twoname || 'unknown'}.txt`);
            this.$message.success('日志导出成功');
        },

        /**
         * 生成日志内容
         */
        dslogGenerateLogContent() {
            let content = `
任务执行日志报告
================

总体统计:
--------
总账户数: ${this.dslogCurrentData.length}
成功账户: ${this.getSuccessCount()}
失败账户: ${this.getErrorCount()}
生成时间: ${new Date().toLocaleString()}

详细日志:
--------
`.trim();

            this.dslogCurrentData.forEach((row, index) => {
                content += `
${index + 1}. ${row.idsname || `账户${index + 1}`}
   计划: ${this.getStatusText(row.planMsg)} ${this.getReasonText(row.planMsg) ? '- ' + this.getReasonText(row.planMsg) : ''}
   广告组: ${this.getStatusText(row.groupMsg)} ${this.getReasonText(row.groupMsg) ? '- ' + this.getReasonText(row.groupMsg) : ''}
   创意: ${this.getStatusText(row.createMsg)} ${this.getReasonText(row.createMsg) ? '- ' + this.getReasonText(row.createMsg) : ''}
   总体: ${this.getOverallStatus(row)}
`;
            });

            return content;
        },

        /**
         * 下载日志文件
         */
        dslogDownloadLogFile(content, filename) {
            const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        },

        /**
         * 关闭对话框
         */
        dslogHandleClose() {
            this.dslogCurrentData = [];
            this.dslogLoading = false;
        },
        dschangeHandleSubmit() {
            this.$refs.dschangeFormRef.validate((valid) => {
                if (valid) {
                    this.dschangeSubmitForm();
                } else {
                    this.$message.error('请填写完整信息');
                    return false;
                }
            });
        },

        /**
         * 提交表单数据
         */
        async dschangeSubmitForm() {


            this.dschangeLoading = true;

            try {
                // 验证执行时间是否为未来时间（只有待执行的任务需要验证）
                if (this.dschangeCurrentStatus === 0) {
                    const selectedTime = new Date(this.dschangeForm.dschangeExecuteTime);
                    const currentTime = new Date();

                    if (selectedTime <= currentTime) {
                        this.$message.error('待执行的任务必须设置未来的时间');
                        this.dschangeLoading = false;
                        return;
                    }
                }

                // 构建提交数据（只提交名称和时间）
                const dschangeSubmitData = {
                    id: this.dschangeCurrentId,
                    taskName: this.dschangeForm.dschangeTaskName.trim(),
                    executeTime: this.dschangeForm.dschangeExecuteTime,
                    status: this.dschangeForm.dschangeStatus
                };

                // 调用API更新数据
                // const response = await this.dschangeUpdateTask(dschangeSubmitData);

                const res = await axios.post(`https://control.zjwec.cn​/api/v1/oppo/pd/task/update`, dschangeSubmitData);
                if (res.data.code == 0) {
                    this.$message.success('任务更新成功');
                    this.dschangeDialogVisible = false;
                    this.fetchdsData()
                    // 触发父组件更新
                    // this.$emit('task-updated');
                } else {
                    this.$message.error(response.message || '更新失败');
                }

            } catch (error) {
                console.error('更新任务失败:', error);
                this.$message.error('更新失败，请重试');
            } finally {
                this.dschangeLoading = false;
            }
        },
        dschangeHandleDialogClose() {
            this.dschangeCurrentId = null;
            this.dschangeCurrentStatus = 0;
            this.dschangeForm = {
                dschangeTaskName: '',
                dschangeExecuteTime: '',
                dschangeStatus: 0
            };

            if (this.$refs.dschangeFormRef) {
                this.$refs.dschangeFormRef.clearValidate();
            }
        },
        templatedsChange(row) {
            this.dschangeCurrentId = row.id;
            this.dschangeCurrentStatus = row.status;

            // 填充表单数据（只填充名称和时间）
            this.dschangeForm = {
                dschangeTaskName: row.taskName || '',
                dschangeExecuteTime: row.executeTime || '',
                dschangeStatus: row.status || 0
            };

            this.dschangeDialogVisible = true;

            // 清除表单验证
            this.$nextTick(() => {
                if (this.$refs.dschangeFormRef) {
                    this.$refs.dschangeFormRef.clearValidate();
                }
            });
        },
        formatTimestamp(timestamp) {
            // 创建Date对象（注意时间戳是毫秒级）
            const date = new Date(timestamp);

            // 获取各时间组件
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
            const day = String(date.getDate()).padStart(2, '0');

            // 组合成YYYY-MM-DD格式
            return `${year}-${month}-${day}`;
        },
        checkClickInterval() {
            const now = Date.now();
            if (now - this.lastClickTime < 5000) {
                const remaining = Math.ceil((5000 - (now - this.lastClickTime)) / 1000);
                this.$message.warning(`请等待${remaining}秒后再试`);
                return false;
            }
            this.lastClickTime = now;
            return true;
        },
        showTimerDialog() {
            return new Promise((resolve) => {
                this.timerDialogVisible = true;

                // 重置表单
                this.timerForm = {
                    name: '',
                    time: ''
                };

                // 设置默认时间为当前时间+1小时
                const now = new Date();
                now.setHours(now.getHours() + 1);
                this.timerForm.time = now.toISOString().slice(0, 16).replace('T', ' ') + ':00';

                // 保存resolve函数以便在对话框按钮中使用
                this.timerResolve = resolve;

                // 清除表单验证
                if (this.$refs.timerFormRef) {
                    this.$nextTick(() => {
                        this.$refs.timerFormRef.clearValidate();
                    });
                }
            });
        },

        /**
         * 处理定时计划确认
         */
        handleTimerConfirm() {
            // 表单验证
            this.$refs.timerFormRef.validate((valid) => {
                if (valid) {
                    // 验证时间是否合法（必须是将来的时间）
                    const selectedTime = new Date(this.timerForm.time);
                    const currentTime = new Date();

                    if (selectedTime <= currentTime) {
                        this.$message.error('请选择未来的时间');
                        return;
                    }

                    // 关闭对话框并返回数据
                    this.timerDialogVisible = false;
                    this.timerResolve({
                        timerName: this.timerForm.name.trim(),
                        executeTime: this.timerForm.time
                    });
                } else {
                    this.$message.error('请填写完整信息');
                    return false;
                }
            });
        },

        /**
         * 处理定时计划取消
         */
        handleTimerCancel() {
            this.timerDialogVisible = false;
            this.lastClickTime = 0
            if (this.timerResolve) {
                this.timerResolve(null); // 返回null表示用户取消
            }
        },

        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.fetchData();
        },

        handledsSizeChange(val) {
            this.dsqueryParams.current = val;
            this.fetchdsData();
        },
        handletamplateCurrentChange(val) {
            this.queryParams.page_no = val;
            this.fetchData();
        },
        handledstamplateCurrentChange(val) {
            this.dsqueryParams.current = val;
            this.fetchdsData();
        },
        handletemplateQuery() {
            this.queryParams.pageNum = 1; // 重置页码
            this.fetchData();
        },

        // 重置查询
        resettemplateQuery() {
            this.queryParams = {
                templateName: '',
                pageNum: 1,
                pageSize: 10
            };
            this.fetchData();
        },
        dshandletemplateQuery() {
            this.dsqueryParams.current = 1; // 重置页码
            this.fetchdsData();
        },

        // 重置查询

        handletemplateSelectionChange(selection) {
            if (selection.length > 0) {
                this.selectedTemplate = selection[0];
                // 清除其他选择，确保只选一个
                // this.$refs.templateTable.clearSelection();
                this.$refs.templateTable.toggleRowSelection(selection[0]);
            } else {
                this.selectedTemplate = null;
            }
        },
        handleDialogClose() {
            this.selectedTemplate = null;
            // this.$refs.templateTable.clearSelection();
        },
        deepParseObject(obj) {
            // 如果不是对象或数组，直接返回
            if (typeof obj !== 'object' || obj === null) return obj;

            // 遍历对象的每个 key
            Object.keys(obj).forEach(key => {
                let value = obj[key];

                // 如果是字符串，尝试 JSON.parse
                if (typeof value == 'string') {
                    console.log(1);
                    try {
                        const parsed = JSON.parse(value);
                        obj[key] = parsed // 递归解析
                    } catch (e) {
                        // 不是 JSON 字符串，保持原值
                        obj[key] = value;
                    }
                }
                // 如果是对象或数组，递归解析
                else if (typeof value === 'object' && value !== null) {
                    obj[key] = deepParseObject(value);
                }
            });

            return obj;
        },
        async templateInfoChange(row) {
            let loading = null;
            loading = this.$loading({
                lock: true,
                text: '正在录入...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            console.log(row);
            let res = this.deepParseObject(row)
            console.log(res);

            //回填
            // this.idsList = res.idsList;

            this.form = {
                ...this.form,
                extension_type: res.extension_type,
                delivery_mode: res.delivery_mode,
                dayLimit: res.day_limit,
                switchPlan: res.switch_plan,
                dayBudget: res.day_limit > 0 ? res.day_budget / 100 : this.form.dayBudget
            };
            this.changeextensionFlow(res.extension_flow)
            this.flowScenechange(res.flow_scene)
            console.log(this.pageType_list.filter(item => item.value == res.page_type));
            this.form2.pageTypelabel = this.pageType_list.filter(item => item.value == res.page_type)[0].label
            console.log(this.form2);
            this.form2 = {
                ...this.form2,
                extensionFlow: res.extension_flow,
                flowScene: res.flow_scene,
                pageType: res.page_type,
                Deeplinktype: res.deeplink_type,
                Deeplinkstatus: res.deeplink_status,
                linkDeskFlag: res.link_desk_flag,
                billingType: res.billing_type,
                defaultSecondStage: res.default_second_stage,
                price: res.price,
                ocpcType: res.ocpc_type,
                ocpcPrice: res.ocpc_price,
                deepOcpcStatus: res.deep_ocpc_status,
                deepOcpcType: res.deep_ocpc_type,
                deepOcpcPrice: res.deep_ocpc_price
            };

            this.form3 = {
                ...this.form3,
                number: res.number,
                buttonTxt: res.button_txt,
                brandName: res.brand_name
            };

            // 直接赋值的属性
            this.parsestatus = res.parsestatus;
            this.isoldgroupprice = res.isoldgroupprice;
            this.mixminvalue = res.mixminvalue;
            this.mixminvaluelate = res.mixminvaluelate;
            this.material_type = res.material_type;
            this.titlesString = res.titles_string;





            loading.close();
            this.templateDialogVisible = false
            // this.getimgvivolist()
        },
        pageTypechang(e) {
            console.log(e);
            this.form2.pageTypelabel = this.pageType_list.filter(item => item.value == e)[0].label
            this.form2.pageType = e
        },
        async handletemplateDelete(row) {
            this.$confirm('确定删除该模板吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await axios.delete(`https://control.zjwec.cn​/oppotemplate​/delete​/${row.id}`);
                console.log(res);
                if (res.data.code == 0) {
                    this.$message.success('删除成功');
                    this.fetchData()
                } else {
                    this.$message.info('删除失败');
                }

            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },
        async dshandletemplateDelete(row) {
            console.log(row);
            this.$confirm('确定删除该模板吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await axios.post(`https://control.zjwec.cn​/api/v1/oppo/pd/task/delete?id=${row.id}`
                );

                console.log(res);
                if (res.data.code == 0) {
                    this.$message.success('删除成功');
                    // this.fetchdsData()
                    this.fetchdsData()
                } else {
                    this.$message.info('删除失败');
                }

            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },
        async fetchData() {
            try {
                const res = await axios.get('https://control.zjwec.cn/oppotemplate/query_template_list', {
                    params: this.queryParams
                });
                console.log(res);
                this.templateList = res.data.records || [];
                this.templatetotal = res.data.total || 0;
            } catch (error) {
                this.$message.error('获取数据失败');
                console.error(error);
            }

        },
        async fetchdsData() {
            try {
                const res = await axios.get('https://control.zjwec.cn​/api/v1/oppo/pd/task/page', {
                    params: this.dsqueryParams
                });
                console.log(res);
                this.dstemplateList = res.data.data.records || [];
                this.dstemplatetotal = res.data.data.total || 0;
            } catch (error) {
                this.$message.error('获取数据失败');
                console.error(error);
            }

        },
        templateDialogVisibleChange() {
            this.templateDialogVisible = true
            this.fetchData()
        },
        dsDialogVisibleChange() {
            this.dsDialogVisible = true
            this.fetchdsData()
        },
        shallowStringifyAll(obj) {
            const result = {};

            // 遍历对象的所有自有属性
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const value = obj[key];

                    // 处理null和undefined
                    if (value === null || value === undefined) {
                        result[key] = '';
                    }
                    // 处理数组和对象（包括嵌套对象和数组）
                    else if (typeof value === 'object') {
                        result[key] = JSON.stringify(value);
                    }
                    // 处理基本类型
                    else {
                        result[key] = String(value);
                    }
                }
            }

            return result;
        },
        templateSave() {
            if (this.form.campaign_name == "") {
                this.$message.warning('广告计划名称为空')
                return
            }
            if (this.form2.pageType == "") {
                this.$message.warning('网页地址类型为空')
                return
            }
            if (!this.isoldgroupprice && !this.form2.price) {
                this.$message.warning('基础出价为空')
                return
            }
            if (this.form3.number == '') {
                this.$message.warning('创意搭建数量为空')
                return
            }
            if (this.material_type == '') {
                this.$message.warning('创意样式为空')
                return
            }
            if (this.form3.buttonTxt == '') {
                this.$message.warning('按钮文案为空')
                return
            }
            if (this.form3.brandName == '') {
                this.$message.warning('品牌名称为空')
                return
            }
            if (this.titlesString == '') {
                this.$message.warning('文案为空')
                return
            }
            let arr = {
                "extension_type": this.form.extension_type,
                "delivery_mode": this.form.delivery_mode,
                "day_limit": this.form.dayLimit,
                "switch_plan": this.form.switchPlan,
                "campaign_name": this.form.campaign_name,


                "extension_flow": this.form2.extensionFlow,
                "flow_scene": this.form2.flowScene,
                "parsestatus": this.parsestatus,
                "page_type": this.form2.pageType,
                "deeplink_type": this.form2.Deeplinktype,
                "deeplink_status": this.form2.Deeplinkstatus,
                "link_desk_flag": this.form2.linkDeskFlag,
                "billing_type": this.form2.billingType,
                "default_second_stage": this.form2.defaultSecondStage,
                "isoldgroupprice": this.isoldgroupprice,
                "price": this.form2.price,
                "ocpc_type": this.form2.ocpcType,
                "ocpc_price": this.form2.ocpcPrice,
                "deep_ocpc_status": this.form2.deepOcpcStatus,
                "deep_ocpc_type": this.form2.deepOcpcType,
                "deep_ocpc_price": this.form2.deepOcpcPrice,

                "mixminvalue": this.mixminvalue,
                "mixminvaluelate": this.mixminvaluelate,
                "number": this.form3.number,
                "material_type": this.material_type,
                "button_txt": this.form3.buttonTxt,
                "brand_name": this.form3.brandName,
                "titles_string": this.titlesString
            }
            if (this.form.dayLimit == 1) {
                arr = { ...arr, day_budget: this.form.dayBudget * 100 }
            } else {
                arr = { ...arr, day_budget: 0 }
            }
            this.$prompt('请输入模板名称', '保存模板', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValidator: (value) => {
                    if (!value || value.trim() === '') {
                        return false; // 返回false会阻止提交
                    }
                    return true;
                },
                inputErrorMessage: '模板名称不能为空'
            }).then(async ({ value }) => {
                let loading = null;
                try {
                    // 确保arr已定义并包含需要保存的数据
                    let templateData = {
                        ...arr, // 替换为您的实际数据源
                        model_name: value.trim()
                    };
                    templateData = this.shallowStringifyAll(templateData)
                    console.log(templateData);


                    // 显示加载中状态
                    loading = this.$loading({
                        lock: true,
                        text: '正在保存模板...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    // 调用接口 - 确保ax是正确配置的axios实例
                    const res = await this.$axios.post('https://control.zjwec.cn/oppotemplate/save', templateData);
                    console.log(res);
                    // 检查接口返回是否成功
                    if (res.data) { // 根据您的接口实际返回修改
                        this.$message.success('保存成功');
                    } else {
                        this.$message.error(res.data.msg || '保存失败');
                    }
                } catch (error) {
                    console.error('保存出错:', error);
                    this.$message.error('保存过程中出错');
                } finally {
                    loading.close();
                }
            }).catch(err => {
                // 这里只会捕获prompt自身的取消操作
                if (err !== 'cancel') {
                    console.log('输入验证失败:', err);
                } else {
                    console.log('用户取消输入');
                }
            });



        },
        clearAllvideos() {
            this.videofileList = [];
            this.videofileListcode = []
            this.$message.success('已清空所有视频');
        },
        clearAllImages() {
            this.tpfileList = [];
            this.tpfileListcode = []
            this.$message.success('已清空所有图片');
        },
        clearAllcoverImages() {
            this.videotpfileList = [];
            this.videofileListcode = []
            this.$message.success('已清空封面图片');
        },
        getStatus(status) {
            switch (status) {
                case "success":
                    return "success";
                case "error":
                    return "error";
                case "active":
                    return "process";
                default:
                    return "wait";
            }
        },
        flowScenechange(string) {
            console.log(string);
            let res = this.styleCategorieslist.filter(item => item.value == string)
            console.log(res.length);
            console.log(res);

            if (res.length > 0) this.styleCategories = res[0].list
            else {
                this.styleCategories = this.styleCategorieslist[0].list
            }
        },
        async findIds() {

            this.ids_list = [],
                await axios.post('https://test.nbweiou.cn/api/oppo/get_ids', {
                    username: this.btgjc,
                    twoname: this.towName
                }).then(async res => {
                    this.ids_list = res.data;

                    const now = new Date();
                    const year = now.getFullYear();
                    const month = now.getMonth() + 1;
                    const pad = (n) => (n < 10 ? '0' + n : n);
                    const beginTime = Number(`${year}${pad(month)}01`);
                    const endTime = Number(`${year}${pad(month)}${pad(now.getDate())}`);

                    // 把所有请求收集到 promises
                    const promises = this.ids_list.map(async (item, index) => {
                        let time1 = Math.floor(Date.now() / 1000);
                        let sign = sha1(item.apiid + item.apikey + time1);
                        let token = Base64.encode(item.ownerid + "," + item.apiid + "," + time1 + "," + sign);

                        const config = {
                            headers: {
                                'Authorization': "Bearer " + token,
                                'Content-Type': "application/x-www-form-urlencoded"
                            }
                        };
                        // let res2=await this.queryWebsideId(token, this.ids_list[index].zzownerid, index)
                        // console.log(res2);

                        const resp = await axios.post(
                            "apis/v3/group/page",
                            qs.stringify({

                                ownerId: this.ids_list[index].zzownerid,
                                page: 1,
                                limit: 25,
                                needStats: 1,
                                beginTime,
                                endTime,
                                extensionTypes: null,
                                extensionFlows: null,
                                flowScenes: null,
                                advertiseTypes: null,
                                deleteFlag: 0,
                                showStatusSet: null,
                                orderByColumn: null,
                                insertTime: null,
                                asc: "DESC",
                                deliveryModes: ""
                            }),
                            config
                        );
                        if (resp.data.data.records.length > 0) {
                            this.ids_list[index].price = resp.data.data.records[0].price;
                            this.ids_list[index].ocpcPrice = resp.data.data.records[0].ocpxPrice || resp.data.data.records[0].ocpcPrice;
                        } else {

                            this.$message.warning('不能获取最新广告组出价')
                        }
                    });
                    // 等待所有请求完成
                    await Promise.all(promises);
                    // 确保 ids_list 更新后再打印
                    // console.log(this.ids_list);
                });
            console.log(this.ids_list);
        },
        async GetRo() {
            await axios.post('https://test.nbweiou.cn/api/oppo/get_vivo_user', {
                'username': this.btgjc
            }).then(
                res => {
                    this.two = res.data
                }
            )
        },
        PlacementTimehange(time) {
            if (time && time.length === 2) {
                const formatted = time.map(date => dayjs(date).format('YYYY-MM-DD'));
                console.log('格式化后:', formatted); // ['2038-01-19', '2038-01-25'] 之类
                // 如果你想保存
                // this.formattedPlacementTime = formatted;
                this.startDate = formatted[0]
                this.endDate = formatted[1]
            } else {
                console.log('未选择日期');
            }
        },
        changeextensionFlow(string) {
            // if(this.form.extension_type!=2)  {
            //     string=2
            //     this.form2.extensionFlow=2
            // }
            console.log(string);
            this.form2.flowScene_choose_list = this.form2.flowScene_list.find(item => item.value == string).list

            switch (string) {
                case "1":
                    this.form2.flowScene = '1'
                    break;
                case "2":
                    this.form2.flowScene = '13'
                    break;
                case "3":
                    this.form2.flowScene = '12'
                    break;

            }


        },
        extensionTypeChange(i) {
            console.log(i);
            const item = this.extensionType_goal_group.find(item => item.value == i);
            this.updatePlanName(item.label)
            console.log(i);
            if (i == 2) {
                this.form2.flowScene_list = [
                    {
                        value: "1",
                        list: [{ value: "1", label: "全流量场景" },]
                    },
                    {
                        value: "2",
                        list: [{ value: "13", label: "展示优选" },
                        { value: "6", label: "信息流" },]
                    }, {
                        value: "3",
                        list: [{ value: "12", label: "联盟通投" },
                        { value: "7", label: "Banner" },
                        { value: "9", label: "插屏" },
                        { value: "10", label: "原生" },
                        { value: "11", label: "激励视频" },]
                    }

                ]
            }
            // console.log(this.ocpcTypeoptions.filter(item=>item.index==i));
            this.form2 = { ...this.form2, ocpcTypeoptions: this.ocpcTypeoptions.filter(item => item.index == i) }
        },
        updatePlanName(typeText) {

            this.form.planName = `${typeText}`;
        },
        timesname() {
            const now = new Date();
            const formattedDate = `${now.getFullYear()}/${String(now.getMonth() + 1).padStart(2, '0')}/${String(now.getDate()).padStart(2, '0')}`;
            const formattedTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
            return `_${formattedDate}_${formattedTime}`
        },
        timesgetFun() {
            const now = new Date();
            const timestamp = now.getTime();
            return timestamp
        },
        async getdingxiangbao() {
            await axios.get('https://control.zjwec.cn/rgionPgk/list').then(res => {
                // console.log(res.data);
                this.dingxiangbao = res.data
            })
        },


        ddddccc(e) {
            console.log(e);
            console.log(this.form2.dingxiangbao);
            let a = JSON.parse(this.form2.dingxiangbao)
            console.log(a);
        },
        async handleGetPlan() {
            const now = Date.now();
            const cooldownTime = 5000; // 5秒冷却时间

            // 检查是否在冷却时间内
            if (now - this.lastGetPlanTime < cooldownTime) {
                const remainingTime = Math.ceil((cooldownTime - (now - this.lastGetPlanTime)) / 1000);
                this.$message.warning(`请等待 ${remainingTime} 秒后再试`);
                return;
            }

            // 如果正在请求中，也直接返回
            if (this.isLoading) {
                this.$message.warning('请求正在进行中，请稍候');
                return;
            }

            this.isLoading = true;
            this.lastGetPlanTime = now;
            this.startCountdown();

            try {
                await this.createdanyuan();
                this.$message.success('操作成功');
            } catch (error) {
                console.error('操作失败:', error);
                this.$message.error('操作失败');
            } finally {
                // this.isLoading = false;
            }
        },

        startCountdown() {
            this.countdown = 5;

            // 清除之前的定时器
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer);
            }

            this.countdownTimer = setInterval(() => {
                this.countdown--;

                if (this.countdown <= 0) {
                    clearInterval(this.countdownTimer);
                    this.isLoading = false
                }
            }, 1000);
        },
        async createdsdanyuan() {
            console.log(this.ids_list);

            if (!this.ids_list.length > 0) {
                this.$message.info('请选择账户！');
                return;
            }
            if (!this.form.campaign_name) {
                this.$message.info('请选择填写广告计划名称！');
                return;
            }
            if (!this.form2.pageTypelabel) {
                this.$message.info('请选择网页地址类型！');
                return;
            }
            if (!this.isoldgroupprice) {
                if (!this.form2.price) {
                    this.$message.info('请填写基础出价！');
                    return
                }
                if (this.form2.billingType == 5) {
                    if (!this.form2.ocpcType) {
                        this.$message.info('请选择转化类型！');
                        return
                    }
                    if (!this.form2.ocpcPrice) {
                        this.$message.info('请填写转化出价！');
                        return
                    }
                }

            }

            if (!this.form3.number) {
                this.$message.info('请填写创意搭建数量！');
                return
            }
            if (!this.material_type) {
                this.$message.info('请选择创意样式！');
                return
            }
            if (!this.form3.buttonTxt) {
                this.$message.info('请填写按钮文案！');
                return
            }
            if (!this.form3.brandName) {
                this.$message.info('请填写品牌名称！');
                return
            }
            if (!this.titlesString) {
                this.$message.info('请填写文案！');
                return
            }





            if (!this.checkClickInterval()) {
                return;
            }

            this.isdsLoading = true;
            let loading = null;

            console.log(this.ids_list);
            console.log("ccccccccccccccccccccccccc");
            const timerInfo = await this.showTimerDialog();
            console.log(this.ids_list);
            console.log("bbbbbbbbbbbbbbbb");
            // 用户取消操作
            if (!timerInfo) {
                this.$message.info('已取消定时计划设置');
                this.isdsLoading = false;
                return;
            }
            // loading = this.$loading({
            //     lock: true,
            //     text: '正在准备定时搭建...',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(0, 0, 0, 0.7)'
            // });

            const { timerName, executeTime } = timerInfo;
            console.log(this.ids_list);
            this.dingshiobj = {
                ids_list: [...this.ids_list],
                timerName,
                executeTime,
                data1: {},
                data2: {},
                data3: [],
            },
                this.uploadPercent = 0
            this.showProgress = true
            let label = this.extensionType_goal_group.find(item => item.value == this.form.extension_type).label
            // let planIdlist = []
            console.log(this.ids_list);

            for (let key = 0; key < this.ids_list.length; key++) {
                this.steps = [
                    {
                        name: '广告计划', status: 'wait',
                    },
                    { name: '广告组', status: 'wait' },
                    { name: '广告创意', status: 'wait' },

                ]
                this.activeStep = 0
                this.uploadPercent = Math.round((key / this.ids_list.length) * 100)
                this.$message.success(`正在搭建第${key}条指令`)
                console.log(`第${key}项：`);
                // console.log(label);
                this.updatePlanName(label)
                this.setStepStatus(0, 'process');
                let data = {
                    planName: this.form.campaign_name,
                    deliveryMode: this.form.delivery_mode,
                    extensionType: this.form.extension_type,
                    dayLimit: this.form.dayLimit,
                    status2: this.form.switchPlan

                }
                if (this.form.dayLimit == 1) {
                    data = { ...data, dayBudget: this.form.dayBudget * 100 }
                }
                let time1 = parseInt(new Date().getTime()) + '';
                time1 = parseInt(time1 / 1000);
                let sign = sha1(this.ids_list[key].apiid + this.ids_list[key].apikey + time1);
                let token = Base64.encode(this.ids_list[key].ownerid + "," + this.ids_list[key].apiid + "," + time1 + "," + sign);
                let config = {
                    headers: {
                        'Authorization': "Bearer " + token,
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                };
                // planIdlisttoken = config

                this.tpfileListcode = []
                this.txfileCode = []
                this.videotpfileListcode = []
                this.videofileListcode = []
                //完成所有素材的上传
                if (this.txfileList.length > 0) {
                    let res = await this.uploadtxImgFile(config, this.ids_list[key].zzownerid)
                    console.log(res);
                }
                if (this.tpfileList.length > 0) {
                    let res = await this.uploadImgFile(config, this.ids_list[key].zzownerid)
                    console.log(res);
                }
                if (this.videotpfileList.length > 0 || this.videofileList.length > 0) {
                    if (this.videotpfileList.length != this.videofileList.length) return

                    let res2 = await this.uploadVideoFile(config, this.ids_list[key].zzownerid)
                    let res = await this.uploadVideoImgFile(config, this.ids_list[key].zzownerid)
                    console.log(res);
                }
                //存计划
                this.dingshiobj.data1 = data

                this.setStepStatus(0, 'success');
                // if(!this.form.switchPlan){


                //自动获取落地页信息
                let parms
                if (this.parsestatus) {
                    parms = await this.queryWebsideId(token, this.ids_list[key].zzownerid, key)
                }
                console.log(parms);

                // }



                let data2 = {
                    // adGroupName: this.ids_list[key].planName + '_' + this.form.planName + this.timesname() + this.form.campaign_name + this.timesgetFun(),
                    extensionFlow: this.form2.extensionFlow,
                    flowScene: this.form2.flowScene,

                    targetId: this.ids_list[key].targetid,
                    billingType: this.form2.billingType,
                    price: this.isoldgroupprice && this.ids_list[key].price ? this.ids_list[key].price : this.form2.price * 100,
                    dayLimit: 0,
                    // timeLimit: 0,
                    ownerId: this.ids_list[key].zzownerid,
                    extensionType: this.form.extension_type,
                    // pageId
                }
                if (this.timeLimit == 1) {
                    data2 = { ...data2, timeLimit: 1, timeSet: this.timeSet }
                } else {
                    data2 = { ...data2, timeLimit: 0 }
                }
                console.log(this.ids_list);
                if (this.form2.Deeplinkstatus) {
                    this.dingshiobj.ids_list[key].haplink = this.ids_list[key].haplink

                }
                if (this.form2.flowScene == 6 || this.form2.flowScene == 7 || this.form2.flowScene == 9 || this.form2.flowScene == 10 || this.form2.flowScene == 11) {
                    data2 = { ...data2, advertiseType: this.form2.dpaProductType }
                }
                if (this.form2.flowScene == 6 && this.form.extension_type == 3) {
                    data2 = { ...data2, linkDeskFlag: this.form2.linkDeskFlag }
                }
                if (this.form.extension_type == 3) {
                    console.log(this.ids_list);
                    data2 = {
                        ...data2,
                        pageType: this.form2.pageType,
                        // pageUrl: this.ids_list[key].url == '' ? "" : this.ids_list[key].url.trim(),
                        instantAppId: this.ids_list[key].appid,
                        instantAppUrl: this.ids_list[key].haplink
                    }
                    this.dingshiobj.ids_list[key] = {
                        ...this.dingshiobj.ids_list[key], // 保留原有属性
                        instantAppId: this.ids_list[key].appid,
                        instantAppUrl: this.ids_list[key].haplink,
                        haplink: ""
                    };
                    // this.ids_list[key].page
                    if (this.parsestatus) {
                        data2 = {
                            ...data2,
                            // pageUrl: parms.pageUrl.trim(),
                            // pageId: parms.pageId,
                        }
                    }
                    if (parms && parms.pageUrl && parms.pageId) {
                        this.dingshiobj.ids_list[key].url = parms.pageUrl
                        this.dingshiobj.ids_list[key].pageId = parms.pageId
                    }

                } else if (this.form.extension_type == 1) {
                    if (this.form2.Deeplinktype == 0) {
                        data2 = {
                            ...data2,
                            Deeplinktype: this.form2.Deeplinktype,
                            pageType: this.form2.pageType,
                            pageUrl: this.ids_list[key].url,
                            // deepUrl: this.ids_list[key].haplink,

                        }
                        if (this.parsestatus) {
                            data2 = {
                                ...data2,
                                // pageUrl: parms.pageUrl.trim(),
                                // pageId: parms.pageId,
                            }
                            if (parms && parms.pageUrl && parms.pageId) {
                                this.dingshiobj.ids_list[key].url = parms.pageUrl ? parms.pageUrl : this.ids_list[key].url
                                this.dingshiobj.ids_list[key].pageId = parms.pageId ? parms.pageId : ""
                            }
                        }
                        if (this.form2.Deeplinkstatus) {
                            data2 = {
                                ...data2,
                                // Deeplinktype:this.form2.Deeplinktype,
                                // pageType: this.form2.pageType,
                                // pageUrl: this.ids_list[key].url,
                                // deepUrl: this.ids_list[key].haplink,

                            }

                        }
                    } else if (this.form2.Deeplinktype == 3) {

                        data2 = {
                            ...data2,
                            Deeplinktype: this.form2.Deeplinktype,
                            pageType: this.form2.pageType,
                            pageUrl: this.ids_list[key].url,
                            instantAppId: this.ids_list[key].appid,
                            instantAppUrl: this.ids_list[key].haplink,
                            // pageId: 1200200596
                        }
                        this.dingshiobj.ids_list[key] = {
                            ...this.dingshiobj.ids_list[key], // 保留原有属性
                            instantAppId: this.ids_list[key].appid,
                            instantAppUrl: this.ids_list[key].haplink,
                            haplink: ""
                        };
                        if (this.parsestatus) {
                            data2 = {
                                ...data2,
                                pageUrl: parms.pageUrl.trim(),
                                pageId: parms.pageId,
                            }
                            if (parms && parms.pageUrl && parms.pageId) {
                                this.dingshiobj.ids_list[key].url = parms.pageUrl ? parms.pageUrl : this.ids_list[key].url
                                this.dingshiobj.ids_list[key].pageId = parms.pageId ? parms.pageId : ""
                            }
                        }
                    }

                }
                if (this.form2.billingType == 5) {
                    console.log(this.isoldgroupprice);
                    console.log(this.ids_list[key].ocpcPrice);
                    if (this.form2.ocpcType == 47) {
                        data2 = {
                            ...data2,
                            targetROI: this.form2.targetROI * 1000000,
                            ocpcType: this.form2.ocpcType,
                            defaultSecondStage: this.form2.defaultSecondStage,
                        }
                    } else {
                        data2 = {
                            ...data2,
                            ocpcPrice: this.isoldgroupprice && this.ids_list[key].ocpcPrice ? this.ids_list[key].ocpcPrice : this.form2.ocpcPrice * 100,
                            ocpcType: this.form2.ocpcType,
                            defaultSecondStage: this.form2.defaultSecondStage,
                        }
                    }

                }

                console.log(data2);
                // this.dingshiobj.data2 = {
                //     config,
                //     data
                // }
                //存广告组
                this.dingshiobj.data2 = data2
                this.setStepStatus(1, 'process');

                let data3 = {
                    ownerId: this.ids_list[key].zzownerid,
                }
                if (this.form3.number < 0) return
                this.setStepStatus(2, 'process');
                await this.createoriginality2(data3, token, key)









            }
            // this.dingshiobj.ids_list = this.ids_list

            console.log(this.dingshiobj);
            let res = await axios.post("https://control.zjwec.cn/api/v1/oppo/pd/task/insert", this.dingshiobj);
            console.log(res);
            if (res.data.code == 0) {
                this.$message.success("创建任务成功");
            } else {
                this.$message.error("创建失败失败:", res.data.message);
            }
            // this.cleanup(loading);
            this.uploadPercent = 100
            this.isdsLoading = false;
            setTimeout(() => {
                this.showProgress = false
            }, 31500)
        },
        cleanup(loading) {
            if (loading) {
                loading.close();
            }
            this.isdsLoading = false;

            setTimeout(() => {
                this.showProgress = false;
                this.uploadPercent = 0;
            }, 2000);
        },
        async queryWebsideId(token, ownerId) {
            const config = {
                headers: {
                    'Authorization': "Bearer " + token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
            let parmm = {
                ownerId: ownerId,
                pageType: this.form2.pageType,
            }
            let parms
            await axios.post('apis/v2/communal/ad/sparkPageNew/list', qs.stringify(parmm), config
            ).then(res => {

                if (res.data.code == 0 && res.data.data.length > 0) {
                    parms = {
                        pageId: res.data.data[0].pageId,
                        pageUrl: res.data.data[0].pageUrl
                    }
                    // console.log(parse);
                } else {
                    this.$message.error('获取落地页失败')

                }
            })
            return parms
        },
        async createdanyuan() {
            // if(this.form2.flowScene == 6 && this.form3.type == 50 || this.form2.flowScene == 10 && this.form3.type == 1 || this.form2.flowScene == 10 && this.form3.type == 50||(this.form2.flowScene == 6 && this.form3.type == 60) || (this.form2.flowScene == 6 && this.form3.type == 63)||(this.form2.flowScene == 10 && this.form3.type == 60) || (this.form2.flowScene == 10 && this.form3.type == 63)){
            //     if(this.txfileList.length == 0){
            //         this.$message.warning('请上传头像')
            //         return
            //     }

            // }
            console.log(this.ids_list);
            // this.tpfileListcode = []
            // this.txfileCode = []
            // this.videotpfileListcode = []
            // this.videofileListcode = []



            this.uploadPercent = 0
            this.showProgress = true
            let label = this.extensionType_goal_group.find(item => item.value == this.form.extension_type).label
            let planIdlist = []
            let planIdlisttoken = ''


            // if (this.isLoading) return;
            // this.isLoading = true;


            // let planidlist=[]
            for (let key = 0; key < this.ids_list.length; key++) {
                this.steps = [
                    {
                        name: '广告计划', status: 'wait',
                    },
                    { name: '广告组', status: 'wait' },
                    { name: '广告创意', status: 'wait' },

                ]
                this.activeStep = 0
                this.uploadPercent = Math.round((key / this.ids_list.length) * 100)
                this.$message.success(`正在搭建第${key}条指令`)
                console.log(`第${key}项：`);
                // console.log(label);
                this.updatePlanName(label)
                this.setStepStatus(0, 'process');

                this.tpfileListcode = []
                this.txfileCode = []
                this.videotpfileListcode = []
                this.videofileListcode = []


                let data = {
                    planName: this.ids_list[key].planName + '_' + this.form.planName + this.timesname() + this.form.campaign_name + this.timesgetFun(),
                    deliveryMode: this.form.delivery_mode,
                    extensionType: this.form.extension_type,
                    dayLimit: this.form.dayLimit,
                    ownerId: this.ids_list[key].zzownerid,
                }
                if (this.form.dayLimit == 1) {
                    data = { ...data, dayBudget: this.form.dayBudget * 100 }
                }
                let time1 = parseInt(new Date().getTime()) + '';
                time1 = parseInt(time1 / 1000);
                let sign = sha1(this.ids_list[key].apiid + this.ids_list[key].apikey + time1);
                let token = Base64.encode(this.ids_list[key].ownerid + "," + this.ids_list[key].apiid + "," + time1 + "," + sign);
                let config = {
                    headers: {
                        'Authorization': "Bearer " + token,
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                };
                planIdlisttoken = config


                //完成所有素材的上传
                if (this.txfileList.length > 0) {
                    let res = await this.uploadtxImgFile(config, this.ids_list[key].zzownerid)
                    console.log(res);
                }
                if (this.tpfileList.length > 0) {
                    let res = await this.uploadImgFile(config, this.ids_list[key].zzownerid)
                    console.log(res);
                }
                if (this.videotpfileList.length > 0 || this.videofileList.length > 0) {
                    if (!this.autoGenerateCover) {
                        if (this.videotpfileList.length != this.videofileList.length) return
                    }

                    let res2 = await this.uploadVideoFile(config, this.ids_list[key].zzownerid)
                    let res = await this.uploadVideoImgFile(config, this.ids_list[key].zzownerid)
                    console.log(res);
                }
                await axios.post('apis/v3/plan/add', qs.stringify(data), config
                ).then(async res => {
                    console.log(res);
                    if (res.data.code != 0) {
                        this.$message({
                            showClose: true,
                            message: res.data.msg
                        });
                        return
                    } else if (res.data.code == 0) {

                        this.setStepStatus(0, 'success');
                        // if(!this.form.switchPlan){
                        let planIds = res.data.data.planId;
                        let status2 = this.form.switchPlan
                        await axios.post('apis/v3/plan/status', qs.stringify({ planIds, status2, ownerId: this.ids_list[key].zzownerid }), config
                        ).then(res => {
                            console.log(res.data)
                        })
                        //自动获取落地页信息
                        let parms
                        if (this.parsestatus) {
                            parms = await this.queryWebsideId(token, this.ids_list[key].zzownerid, key)
                        }
                        console.log(parms);

                        // }

                        planIdlist = [...planIdlist, res.data.data.planId]

                        let data2 = {
                            planId: res.data.data.planId,
                            adGroupName: this.ids_list[key].planName + '_' + this.form.planName + this.timesname() + this.form.campaign_name + this.timesgetFun(),
                            extensionFlow: this.form2.extensionFlow,
                            flowScene: this.form2.flowScene,
                            extensionType: this.form.extension_type,
                            targetId: this.ids_list[key].targetid,
                            billingType: this.form2.billingType,
                            price: this.isoldgroupprice && this.ids_list[key].price ? this.ids_list[key].price : this.form2.price * 100,
                            dayLimit: 0,
                            // timeLimit: 0,
                            ownerId: this.ids_list[key].zzownerid,
                        }
                        
                        if (this.timeLimit == 1) {
                            data2 = { ...data2, timeLimit: 1, timeSet: this.timeSet }
                        } else {
                            data2 = { ...data2, timeLimit: 0 }
                        }
                        if (this.form2.flowScene == 6 || this.form2.flowScene == 7 || this.form2.flowScene == 9 || this.form2.flowScene == 10 || this.form2.flowScene == 11) {
                            data2 = { ...data2, advertiseType: this.form2.dpaProductType }
                        }
                        if (this.form2.flowScene == 6 && this.form.extension_type == 3) {
                            data2 = { ...data2, linkDeskFlag: this.form2.linkDeskFlag }
                        }
                        if (this.form.extension_type == 3) {
                            data2 = {
                                ...data2,
                                pageType: this.form2.pageType,
                                pageUrl: this.ids_list[key].url == '' ? "" : this.ids_list[key].url,
                                instantAppId: this.ids_list[key].appid,
                                instantAppUrl: this.ids_list[key].haplink
                            }
                            if (this.parsestatus) {
                                data2 = {
                                    ...data2,
                                    pageUrl: parms.pageUrl,
                                    pageId: parms.pageId,
                                    
                                }
                            }
                        } else if (this.form.extension_type == 1) {
                            if (this.form2.Deeplinktype == 0) {
                                data2 = {
                                    ...data2,
                                    // Deeplinktype: this.form2.Deeplinktype,
                                    pageType: this.form2.pageType,
                                    pageUrl: this.ids_list[key].url,
                                    // deepUrl: this.ids_list[key].haplink,

                                }
                                if (this.parsestatus) {
                                    data2 = {
                                        ...data2,
                                        pageUrl: parms.pageUrl.trim(),
                                        pageId: parms.pageId,
                                    }
                                }
                                if (this.form2.Deeplinkstatus) {
                                    data2 = {
                                        ...data2,
                                        // Deeplinktype:this.form2.Deeplinktype,
                                        // pageType: this.form2.pageType,
                                        // pageUrl: this.ids_list[key].url,
                                        deepUrl: this.ids_list[key].haplink,

                                    }
                                }
                            } else if (this.form2.Deeplinktype == 3) {
                                data2 = {
                                    ...data2,
                                    Deeplinktype: this.form2.Deeplinktype,
                                    pageType: this.form2.pageType,
                                    pageUrl: this.ids_list[key].url,
                                    instantAppId: this.ids_list[key].appid,
                                    instantAppUrl: this.ids_list[key].haplink,
                                    // pageId: 1200200596
                                }
                                if (this.parsestatus) {
                                    data2 = {
                                        ...data2,
                                        pageUrl: parms.pageUrl.trim(),
                                        pageId: parms.pageId,
                                    }
                                }
                            }

                        }
                        if(this.form.extension_type==2){
                            data2={
                                ...data2,
                                appId:this.ids_list[key].appid,
                                pageType:this.form2.pageType,
                                pageId:this.ids_list[key].haplink
                            }
                        }
                        if (this.form2.billingType == 5) {
                            console.log(this.isoldgroupprice);
                            console.log(this.ids_list[key].ocpcPrice);
                            if (this.form2.ocpcType == 47) {
                                data2 = {
                                    ...data2,
                                    targetROI: this.form2.targetROI * 1000000,
                                    ocpcType: this.form2.ocpcType,
                                    defaultSecondStage: this.form2.defaultSecondStage,
                                }
                            } else {
                                data2 = {
                                    ...data2,
                                    ocpcPrice: this.isoldgroupprice && this.ids_list[key].ocpcPrice ? this.ids_list[key].ocpcPrice : this.form2.ocpcPrice * 100,
                                    ocpcType: this.form2.ocpcType,
                                    defaultSecondStage: this.form2.defaultSecondStage,
                                }
                            }

                        }
                        if(this.form2.deepOcpcStatus){
                            data2 = {
                                    ...data2,
                                    deepOcpcType: this.form2.deepOcpcType,
                                    deepOcpcPrice: this.form2.deepOcpcPrice,
                                }
                        }

                        console.log(data2);
                        this.setStepStatus(1, 'process');
                        await axios.post('apis/v3/group/add', qs.stringify(data2), config
                        ).then(async res => {
                            // console.log(?)
                            console.log(res.data.data)
                            if (res.data.code == 0) {
                                this.setStepStatus(1, 'success');
                                let data3 = {
                                    adGroupId: res.data.data.adGroupId,
                                    adPlanId: res.data.data.planId,
                                    adName: res.data.data.adGroupName,
                                    ownerId: this.ids_list[key].zzownerid,

                                }
                                if (this.ids_list[key].baoguangurl != "") {
                                    data3 = { ...data3, exposeUrl: this.ids_list[key].baoguangurl }
                                }
                                if (this.form3.number < 0) return
                                this.setStepStatus(2, 'process');
                                await this.createoriginality(data3, token, key)

                            }
                            // console.log(res.data.data.adGroupId)
                            // this.ids_list[parms.id].groundId = res.data.data.adGroupId

                        })


                    }
                })








            }


            this.uploadPercent = 100
            setTimeout(() => {
                this.showProgress = false
            }, 31500)
            this.isLoading = false;
        },
        isoldgrouppriceChang(e) {
            console.log(e);
            this.isIndeterminate = e
        },
        parsestatusChang(e) {
            console.log(e);
            this.parsestatus = e
        },
        setStepStatus(index, status) {
            this.steps[index].status = status;
            this.currentStep = index;
        },
        getBuildIndexes(countPerBuild) {
            if (!this.tpfileListcode.length) return
            const indexes = [];

            for (let i = 0; i < countPerBuild; i++) {
                // console.log(this.tpfileListcode.length);
                const index = (this.currentIndeximg + i) % this.tpfileListcode.length;
                indexes.push(index);
            }

            this.currentIndeximg = (this.currentIndeximg + countPerBuild) % this.tpfileListcode.length;

            return indexes;
        },
        getBuildvideoIndexes(countPerBuild) {
            if (!this.videofileListcode.length) return
            const indexes = [];

            for (let i = 0; i < countPerBuild; i++) {
                // console.log(this.tpfileListcode.length);
                const index = (this.currentIndexvideo + i) % this.videofileListcode.length;
                indexes.push(index);
            }

            this.currentIndexvideo = (this.currentIndexvideo + countPerBuild) % this.videofileListcode.length;

            return indexes;
        },
        getBuildtextIndexes(countPerBuild) {
            let res = this.titlesString
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行
            if (!res.length) return
            const indexes = [];

            for (let i = 0; i < countPerBuild; i++) {
                // console.log(this.tpfileListcode.length);
                const index = (this.currentIndextext + i) % res.length;
                indexes.push(index);
            }

            this.currentIndextext = (this.currentIndextext + countPerBuild) % res.length;

            return indexes;
        },



        async createoriginality(data, token, key) {
            console.log("开始搭建创意");
            console.log(this.form2.flowScene);
            console.log(this.form3.type);
            const config = {
                headers: {
                    'Authorization': "Bearer " + token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

            // if (this.videofileList.length > 0) {

            //     console.log(res);
            // }


            let imgcode = this.tpfileListcode
            let covercode = this.videotpfileListcode
            let videocode = this.videofileListcode

            let textlist = this.titlesString
                .split('\n')
                .map(line => line.trim())
                .filter(line => line);

            if (this.mixminvalue) {
                imgcode = this.shuffleArray(imgcode)
                textlist = this.shuffleArray(textlist)
            }

            if (this.mixminvaluelate == "重复") {
                this.currentIndexvideo = 0
            }



            this.setStepStatus(2, 'success');


            if ((this.form2.flowScene == 6 && this.form3.type == 60) || (this.form2.flowScene == 6 && this.form3.type == 63) || (this.form2.flowScene == 10 && this.form3.type == 60) || (this.form2.flowScene == 10 && this.form3.type == 63) || (this.form2.flowScene == 12 && this.form3.type == 60) || (this.form2.flowScene == 12 && this.form3.type == 63) || (this.form2.flowScene == 11 && this.form3.type == 60) || (this.form2.flowScene == 11 && this.form3.type == 63)) {
                // console.log(1);
                console.log("视频类");
                let addList = [];
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data, adName: data.adName + index + '_' + Date.now() };
                    // let imgindexlist=await this.getBuildIndexes(this.form3.number)
                    let videoIndexelist = await this.getBuildvideoIndexes(this.form3.number)

                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;



                    if ((this.form2.flowScene != 12) && (this.form2.extensionFlow != 3)) {
                        arr.videoImgId = covercode[videoIndexelist[index]];
                    } else if (this.form2.flowScene == 12 && this.form3.type == 60 && this.form.extension_type == 1) {
                        arr.videoImgId = covercode[videoIndexelist[index]];
                    } else if (this.form2.flowScene == 12 && this.form3.type == 63 && this.form.extension_type == 1) {
                        arr.videoBgImg = covercode[videoIndexelist[index]];
                    }


                    arr.videoMatIds = videocode[videoIndexelist[index]];

                    if (this.form2.flowScene != 11) {
                        arr.brandLogoImgId = this.txfileCode[0]
                    }

                    if (this.form3.type == 63 || (this.form2.flowScene == 11 && this.form3.type == 60) || (this.form2.flowScene == 11 && this.form3.type == 63)) {
                        arr.buttonTxt = this.form3.buttonTxt
                    }

                    addList.push(arr)
                }
                let add = {
                    'addList': addList,
                    'ownerId': this.ids_list[key].zzownerid,
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            } else if ((this.form2.flowScene == 6 && this.form3.type == 1) || (this.form2.flowScene == 6 && this.form3.type == 50) || (this.form2.flowScene == 10 && this.form3.type == 1) || (this.form2.flowScene == 10 && this.form3.type == 50)) {
                let addList = [];
                console.log(2);
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data, adName: data.adName + index + '_' + Date.now() };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)
                    // let videoIndexelist = await this.getBuildvideoIndexes(this.form3.number)
                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    // arr.videoImgId = covercode[videoIndexelist[index]];
                    arr.imgMatIds = imgcode[imgindexlist[index]];
                    arr.brandLogoImgId = this.txfileCode[0]
                    arr.buttonTxt = this.form3.buttonTxt

                    if (this.form2.flowScene == 6 && this.form2.extensionFlow == 2) {
                        if (this.ids_list[key].creativityid) {
                            arr.creativityId = this.ids_list[key].creativityid
                        }

                    }

                    addList.push(arr)
                }
                let add = {
                    'ownerId': this.ids_list[key].zzownerid,
                    'addList': addList
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            } else if (this.form2.flowScene == 10 && this.form3.type == 1) {
                console.log(3);
                let addList = [];
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data, adName: data.adName + index + '_' + Date.now() };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)
                    // let videoIndexelist = await this.getBuildvideoIndexes(this.form3.number)
                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    // arr.videoImgId = covercode[videoIndexelist[index]];
                    arr.imgMatIds = imgcode[imgindexlist[index]];
                    arr.buttonTxt = this.form3.buttonTxt
                    // arr.brandLogoImgId = this.txfileCode[0]

                    addList.push(arr)
                }
                let add = {
                    'addList': addList,
                    'ownerId': this.ids_list[key].zzownerid,
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            } else if (this.form2.flowScene == 8 && this.form3.type == 5) {
                let addList = [];
                console.log(4);
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data, adName: data.adName + index + '_' + Date.now() };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)


                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    arr.imgMatIds = imgcode[imgindexlist[index]];


                    addList.push(arr)
                }
                let add = {
                    'addList': addList,
                    'ownerId': this.ids_list[key].zzownerid,
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            } else if (this.form2.flowScene == 12 && this.form3.type == 5) {
                let addList = [];
                console.log(4);
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data, adName: data.adName + index + '_' + Date.now() };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)


                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    arr.imgMatIds = imgcode[imgindexlist[index]];


                    addList.push(arr)
                }
                let add = {
                    'addList': addList,
                    'ownerId': this.ids_list[key].zzownerid,
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            } else if (this.form2.flowScene == 12 && this.form3.type == 34) {
                let addList = [];
                console.log(4);
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data, adName: data.adName + index + '_' + Date.now() };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)
                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)

                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    arr.imgMatIds = imgcode[imgindexlist[index]];
                    arr.copywriter = textlist[textIndexelist[index]]
                    if (this.ids_list[key].creativityid) {
                        arr.creativityId = this.ids_list[key].creativityid
                    }


                    addList.push(arr)
                }
                let add = {
                    'addList': addList,
                    'ownerId': this.ids_list[key].zzownerid,
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            } else if (this.form2.flowScene == 8 && this.form3.type == 34) {
                console.log(5);
                let addList = [];
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data, adName: data.adName + index + '_' + Date.now() };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)
                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    arr.imgMatIds = imgcode[imgindexlist[index]];

                    addList.push(arr)
                }
                let add = {
                    'addList': addList,
                    'ownerId': this.ids_list[key].zzownerid,
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            } else if (this.form2.flowScene == 12 && this.form3.type == 1 || this.form2.flowScene == 12 && this.form3.type == 50 || this.form2.flowScene == 12 && this.form3.type == 1 || this.form2.flowScene == 12 && this.form3.type == 50) {
                let addList = [];
                console.log(2);
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data, adName: data.adName + index + '_' + Date.now() };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)
                    // let videoIndexelist = await this.getBuildvideoIndexes(this.form3.number)
                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    // arr.videoImgId = covercode[videoIndexelist[index]];
                    arr.imgMatIds = imgcode[imgindexlist[index]];
                    // arr.brandLogoImgId = this.txfileCode[0]
                    arr.buttonTxt = this.form3.buttonTxt

                    addList.push(arr)
                }
                let add = {
                    'ownerId': this.ids_list[key].zzownerid,
                    'addList': addList
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            }else if (this.form.extension_type==2&&this.form2.flowScene==13&&this.form3.type==71) {
                let addList = [];
                console.log(2);
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data, adName: data.adName + index + '_' + Date.now() };
                    // let imgindexlist = await this.getBuildIndexes(this.form3.number)
                    // let videoIndexelist = await this.getBuildvideoIndexes(this.form3.number)
                    // let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    // arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    // arr.videoImgId = covercode[videoIndexelist[index]];
                    // arr.imgMatIds = imgcode[imgindexlist[index]];
                    // arr.brandLogoImgId = this.txfileCode[0]
                    // arr.buttonTxt = this.form3.buttonTxt

                    addList.push(arr)
                }
                let add = {
                    'ownerId': this.ids_list[key].zzownerid,
                    'addList': addList
                }
                console.log(add);
                await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                ).then(res => {

                    console.log(res.data);
                    //广告组ID

                })
            }

        },
        async createoriginality2(data, token, key) {
            let arrs = []
            const config = {
                headers: {
                    'Authorization': "Bearer " + token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

            // if (this.videofileList.length > 0) {

            //     console.log(res);
            // }


            let imgcode = this.tpfileListcode
            let covercode = this.videotpfileListcode
            let videocode = this.videofileListcode

            let textlist = this.titlesString
                .split('\n')
                .map(line => line.trim())
                .filter(line => line);

            if (this.mixminvalue) {
                imgcode = this.shuffleArray(imgcode)
                textlist = this.shuffleArray(textlist)
            }

            if (this.mixminvaluelate == "重复") {
                this.currentIndexvideo = 0
            }



            this.setStepStatus(2, 'success');

            let adds = []
            if ((this.form2.flowScene == 6 && this.form3.type == 60) || (this.form2.flowScene == 6 && this.form3.type == 63) || (this.form2.flowScene == 10 && this.form3.type == 60) || (this.form2.flowScene == 10 && this.form3.type == 63)) {
                console.log(1);

                let addList = [];
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data };
                    // let imgindexlist=await this.getBuildIndexes(this.form3.number)
                    let videoIndexelist = await this.getBuildvideoIndexes(this.form3.number)

                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)
                    console.log(textIndexelist);
                    console.log(textlist);
                    console.log(textIndexelist[index]);
                    console.log(textlist[textIndexelist[index]]);




                    arr.copywriter =
                        arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    arr.videoImgId = covercode[videoIndexelist[index]];
                    arr.videoMatIds = videocode[videoIndexelist[index]];
                    arr.brandLogoImgId = this.txfileCode[0]

                    if (this.form3.type == 63) {
                        arr.buttonTxt = this.form3.buttonTxt
                    }


                    addList.push(arr)
                }
                let add = {
                    'ownerId': this.ids_list[key].zzownerid,
                    'addList': addList
                }
                adds = add
                // console.log(add);
                // await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                // ).then(res => {

                //     console.log(res.data);
                //     //广告组ID

                // })
            } else if (this.form2.flowScene == 6 && this.form3.type == 1 || this.form2.flowScene == 6 && this.form3.type == 50 || this.form2.flowScene == 10 && this.form3.type == 1 || this.form2.flowScene == 10 && this.form3.type == 50) {
                let addList = [];
                console.log(2);
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)
                    // let videoIndexelist = await this.getBuildvideoIndexes(this.form3.number)
                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    // arr.videoImgId = covercode[videoIndexelist[index]];
                    arr.imgMatIds = imgcode[imgindexlist[index]];
                    arr.brandLogoImgId = this.txfileCode[0]
                    arr.buttonTxt = this.form3.buttonTxt

                    addList.push(arr)
                }
                let add = {
                    'ownerId': this.ids_list[key].zzownerid,
                    'addList': addList
                }
                adds = addList
                // console.log(add);
                // await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                // ).then(res => {

                //     console.log(res.data);
                //     //广告组ID

                // })
            } else if (this.form2.flowScene == 10 && this.form3.type == 1) {
                console.log(3);
                let addList = [];
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)
                    // let videoIndexelist = await this.getBuildvideoIndexes(this.form3.number)
                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    // arr.videoImgId = covercode[videoIndexelist[index]];
                    arr.imgMatIds = imgcode[imgindexlist[index]];
                    arr.buttonTxt = this.form3.buttonTxt
                    // arr.brandLogoImgId = this.txfileCode[0]

                    addList.push(arr)
                }
                let add = {
                    'ownerId': this.ids_list[key].zzownerid,
                    'addList': addList
                }
                adds = addList
                console.log(add);
                // await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                // ).then(res => {

                //     console.log(res.data);
                //     //广告组ID

                // })
            } else if (this.form2.flowScene == 8 && this.form3.type == 5) {
                let addList = [];
                console.log(4);
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)


                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    arr.imgMatIds = imgcode[imgindexlist[index]];


                    addList.push(arr)
                }
                let add = {
                    'ownerId': this.ids_list[key].zzownerid,
                    'addList': addList
                }
                adds = addList
                // console.log(add);
                // await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                // ).then(res => {

                //     console.log(res.data);
                //     //广告组ID

                // })
            } else if (this.form2.flowScene == 8 && this.form3.type == 34) {
                console.log(5);
                let addList = [];
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)
                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    arr.imgMatIds = imgcode[imgindexlist[index]];

                    addList.push(arr)
                }
                let add = {
                    'ownerId': this.ids_list[key].zzownerid,
                    'addList': addList
                }
                console.log(add);
                adds = addList
                // await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                // ).then(res => {

                //     console.log(res.data);
                //     //广告组ID

                // })
            } else if (this.form2.flowScene == 12 && this.form3.type == 1 || this.form2.flowScene == 12 && this.form3.type == 50 || this.form2.flowScene == 12 && this.form3.type == 1 || this.form2.flowScene == 12 && this.form3.type == 50) {
                let addList = [];
                console.log(2);
                for (let index = 0; index < this.form3.number; index++) {
                    let arr = { ...data };
                    let imgindexlist = await this.getBuildIndexes(this.form3.number)
                    // let videoIndexelist = await this.getBuildvideoIndexes(this.form3.number)
                    let textIndexelist = await this.getBuildtextIndexes(this.form3.number)


                    arr.copywriter = textlist[textIndexelist[index]]
                    arr.brandName = this.form3.brandName;
                    arr.globalSpecId = this.form3.type;
                    arr.clickUrl = this.ids_list[key].xiaoshuourl;
                    // arr.videoImgId = covercode[videoIndexelist[index]];
                    arr.imgMatIds = imgcode[imgindexlist[index]];
                    // arr.brandLogoImgId = this.txfileCode[0]
                    arr.buttonTxt = this.form3.buttonTxt

                    addList.push(arr)
                }
                let add = {
                    'ownerId': this.ids_list[key].zzownerid,
                    'addList': addList
                }
                adds = addList
                console.log(add);
                // await axios.post('apis/v3/ad/batch', qs.stringify(add, { allowDots: true }), config
                // ).then(res => {

                //     console.log(res.data);
                //     //广告组ID

                // })
            }

            this.dingshiobj.data3 = [...this.dingshiobj.data3, ...adds]


        },
        shuffleArray(array) {
            const newArray = [...array]; // 创建副本，不影响原数组
            for (let i = newArray.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [newArray[i], newArray[j]] = [newArray[j], newArray[i]]; // 交换元素
            }
            return newArray;
        },
        removeEmptyFields(obj) {
            console.log(obj);

            return Object.fromEntries(Object.entries(obj).filter(([_, v]) =>
                v != null && v !== '' && !(Array.isArray(v) && v.length === 0)
            ))
        },
        async handlelistByUbs() {
            // this.ids_list = []
            // let arr = this.btgjc.split('\n').filter(line => line.trim());
            await axios.get('https://control.zjwec.cn/api/qttad/directives/all', {
                params: { userId: this.userId },
            }).then(res => {
                console.log(res);
                this.records = res.data
            });

        },
        async recordsChange(e) {
            this.GetRo()
        },
        GetRoChange() {
            this.findIds()
        },
        form3Numberchange(str) {
            console.log(str);
            // let res = this.getBuildtextIndexes(5)
            console.log(res);
        },
        // handlelistByUbs() {
        //     this.ids_list = []
        //     let arr = this.btgjc.split('\n').filter(line => line.trim());
        //     Promise.all(
        //         arr.map(item => {
        //             return axios.get('https://control.zjwec.cn/api/qttpd/listByUbs', {
        //                 params: { ubs: item },
        //             });
        //         })
        //     ).then(responses => {
        //         console.log('所有请求完成:', responses);
        //         let arr2 = []
        //         // 处理所有返回结果
        //         responses.forEach((res, index) => {
        //             console.log(`第${index + 1}个结果:`, res.data);
        //             arr2 = [...arr2, ...res.data]
        //         });
        //         console.log(arr2);
        //         axios.get('https://control.zjwec.cn/api/qtttoken/list').then(res2 => {
        //             console.log(res2.data);


        //             this.ids_list = arr2.map(customer => {
        //                 // 首先尝试用 khname 匹配
        //                 let matchedUser = res2.data.find(user => user.uname === customer.khname);



        //                 // 如果找到匹配用户，则添加 utoken
        //                 if (matchedUser) {
        //                     return {
        //                         ...customer,
        //                         utoken: matchedUser.utoken
        //                     };
        //                 }

        //                 // 没有匹配则保持原样
        //                 return customer;
        //             });
        //             this.getdmplist()
        //             // console.log(this.ids_list);

        //         })


        //     }).catch(error => {
        //         console.error('请求出错:', error);
        //     });
        //     console.log(this.ids_list);
        // },
        handleChange(value) {
            console.log('选中的值:', value);
            this.form2.audience_orient = value
        },
        handleChange2(value) {
            console.log('选中的值:', value);
            this.form2.audience_orient_filter = value
        },
        getdmplist() {
            console.log(this.ids_list);
            axios.get('/qttupapi/openapi/v1/conv/dmp/list', {
                params: {
                    account_id: this.ids_list[0].accountId
                },
                headers: {
                    'Content-Type': 'application/json',
                    'OGW_ACCESS_TOKEN': this.ids_list[0].utoken
                }
            })
                .then(res => {
                    console.log('请求成功:', res.data);

                    this.audience_list = res.data.data.filter(item => item.category_name == "dmp推荐人群")[0]
                    this.options = [{
                        value: this.audience_list.category_id,
                        label: this.audience_list.category_name,
                        children: this.audience_list.audience_list.map(item => ({
                            value: item.audience_id,
                            label: item.audience_name,
                            rawData: item // 保留原始数据 
                        }))
                    }]
                    console.log(this.audience_list);
                })
                .catch(error => {
                    console.error('请求失败:', error);
                    if (error.response) {
                        console.log('错误状态码:', error.response.status);
                        console.log('错误响应数据:', error.response.data);
                    }
                });
        },

        handleInput2() {
            this.form3.second_title = this.titlesString2
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行

            console.log(this.form3.second_title);

            // 检查每一行是否在字数限制（8-23）内
            // this.linesWithLimitError = this.form3.title
            //     .map((line, index) => ({
            //         line: line,
            //         index: index + 1,
            //         length: line.length,
            //     }))
            //     .filter(item => item.length < 8 || item.length > 23) // 不在范围内的行
            //     .map(item => item.line); // 只返回文本内容



            // 如果存在超出字符数的行，更新提示信息
        },
        handleInput() {
            this.form3.title = this.titlesString
                .split('\n')
                .map(line => line.trim())
                .filter(line => line); // 去除空行

            console.log(this.form3.title);

            // 检查每一行是否在字数限制（8-23）内
            this.linesWithLimitError = this.form3.title
                .map((line, index) => ({
                    line: line,
                    index: index + 1,
                    length: line.length,
                }))
                .filter(item => item.length < 0 || item.length > 35) // 不在范围内的行
                .map(item => item.line); // 只返回文本内容



            // 如果存在超出字符数的行，更新提示信息
        },

        handleRemove2(file) {
            this.videofileListcode = []
            const tp = this.videofileList.findIndex(function (item) {
                return item.uid === file.uid;
            });
            if (tp !== -1) {
                this.videofileList.splice(tp, 1);
            }
        },
        videohandleFileChange(file, fileList) {
            console.log(file);
            if (file.status !== 'ready') return;

            // 保持原有的视频列表更新逻辑不变
            this.videofileList = fileList.map(item => {
                return {
                    ...item,
                    url: item.url || URL.createObjectURL(item.raw),
                    file: item
                };
            });

            console.log(this.videofileList);

            if (this.autoGenerateCover) {
                this.extractFrameForNewVideo(file);
            }

        },


        async extractFrameForNewVideo(file) {
            try {
                if (file.status !== 'ready') return;

                console.log('开始为新增视频抽帧:', file.name);

                // 找到文件在列表中的索引
                const fileIndex = this.videofileList.findIndex(item => item.uid === file.uid);
                if (fileIndex === -1) {
                    console.warn('未找到文件在列表中的位置');
                    return;
                }

                const frameResult = await this.extractFrameFromVideoFile(file, fileIndex);

                if (frameResult) {
                    this.addFrameToCoverList(frameResult, fileIndex);

                    this.$message({
                        message: `视频 "${file.name}" 抽帧成功`,
                        type: 'success',
                        duration: 2000
                    });
                }

            } catch (error) {
                console.warn(`视频 "${file.name}" 抽帧失败:`, error);

                this.$message({
                    message: `视频 "${file.name}" 抽帧失败: ${error.message}`,
                    type: 'warning',
                    duration: 3000
                });
            }
        },


        async extractFrameFromVideoFile(videoItem, index) {
            return new Promise((resolve, reject) => {
                const video = document.createElement('video');
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                // 获取视频文件
                const videoFile = videoItem.raw;

                if (!videoFile || !videoFile.type.startsWith('video/')) {
                    reject(new Error('不是有效的视频文件'));
                    return;
                }

                const videoURL = URL.createObjectURL(videoFile);
                video.src = videoURL;
                video.muted = true;
                video.playsInline = true;
                video.crossOrigin = 'anonymous';

                video.addEventListener('loadeddata', () => {
                    canvas.width = video.videoWidth || 640;
                    canvas.height = video.videoHeight || 360;
                    video.currentTime = 0.1;
                });

                video.addEventListener('seeked', () => {
                    try {
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                        canvas.toBlob((blob) => {
                            if (!blob) {
                                reject(new Error('Canvas转换失败'));
                                return;
                            }

                            const frameFile = new File([blob], `封面_${videoFile.name.replace(/\.[^/.]+$/, "")}.jpg`, {
                                type: 'image/jpeg',
                                lastModified: Date.now()
                            });

                            URL.revokeObjectURL(videoURL);

                            resolve({
                                frameFile: frameFile,
                                videoIndex: index,
                                videoName: videoFile.name
                            });

                        }, 'image/jpeg', 0.85);

                    } catch (error) {
                        URL.revokeObjectURL(videoURL);
                        reject(error);
                    }
                });

                video.addEventListener('error', (e) => {
                    URL.revokeObjectURL(videoURL);
                    reject(new Error(`视频加载失败: ${e.message}`));
                });

                setTimeout(() => {
                    URL.revokeObjectURL(videoURL);
                    reject(new Error('视频帧提取超时'));
                }, 15000);
            });
        },


        addFrameToCoverList(frameResult, videoIndex) {
            const { frameFile, videoName } = frameResult;

            const coverFileItem = {
                uid: `frame_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
                name: `封面_${videoName.replace(/\.[^/.]+$/, "")}.jpg`,
                size: frameFile.size,
                type: frameFile.type,
                raw: frameFile,
                url: URL.createObjectURL(frameFile),
                status: 'success',
                isFrame: true,
                sourceVideoIndex: videoIndex,
                sourceVideoName: videoName
            };

            // 确保封面列表存在
            if (!this.videotpfileList) {
                this.videotpfileList = [];
            }

            this.insertCoverInOrder(coverFileItem, videoIndex);

            console.log(`新增封面:`, coverFileItem);
            console.log(`当前封面列表顺序:`, this.videotpfileList.map(item => item.sourceVideoIndex));

            // 触发响应式更新
            this.$forceUpdate();

            this.$message({
                message: `已为 "${videoName}" 生成封面`,
                type: 'success',
                duration: 1500
            });
        },


        insertCoverInOrder(coverFileItem, videoIndex) {
            // 如果列表为空，直接添加
            if (this.videotpfileList.length === 0) {
                this.videotpfileList.push(coverFileItem);
                return;
            }

            // 查找插入位置
            let insertIndex = this.videotpfileList.length;

            for (let i = 0; i < this.videotpfileList.length; i++) {
                const currentCover = this.videotpfileList[i];

                // 如果找到相同视频索引的封面，替换它
                if (currentCover.sourceVideoIndex === videoIndex) {
                    this.videotpfileList.splice(i, 1, coverFileItem);
                    return;
                }

                // 找到第一个比当前视频索引大的位置，插入到它前面
                if (currentCover.sourceVideoIndex > videoIndex) {
                    insertIndex = i;
                    break;
                }
            }

            // 插入到正确位置
            this.videotpfileList.splice(insertIndex, 0, coverFileItem);
        },
        txReset() {
            this.txList = []
        },
        txhandleConfirmUpload() { },
        txhandleUploadSuccess() {
            this.$message.success('上传成功')
        },
        tphandleUploadSuccess() {
            this.$message.success('上传成功')
        },
        tphandleFileChange(file, txList) {
            console.log(file);
            // 只处理新添加的文件（status为'ready'）
            if (file.status !== 'ready') return;
            this.tpfileList = [...this.tpfileList, {
                name: file.name,
                url: file.url,
                uid: file.uid || new Date().getTime(), // 必须有 uid
                status: 'success',
                file
            }]

        },
        videotphandleFileChange(file, txList) {
            // 只处理新添加的文件（status为'ready'）
            if (file.status !== 'ready') return;
            this.videotpfileList = [...this.videotpfileList, {
                name: file.name,
                url: file.url,
                uid: file.uid || new Date().getTime(), // 必须有 uid
                status: 'success',
                file
            }]

        },
        tphandleRemove(file) {
            this.tpfileListcode = []
            const tp = this.tpfileList.findIndex(function (item) {
                return item.uid === file.uid;
            });
            if (tp !== -1) {
                this.tpfileList.splice(tp, 1);
            }
            console.log(this.tpfileList);
            console.log(this.tpfileListcode);
        },
        videotphandleRemove(file) {
            this.videotpfileListcode = []
            const tp = this.videotpfileList.findIndex(function (item) {
                return item.uid === file.uid;
            });
            if (tp !== -1) {
                this.videotpfileList.splice(tp, 1);
            }
            console.log(this.videotpfileList);
            console.log(this.videotpfileListcode);
        },
        tphandlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        videotphandlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        txhandleFileChange(file, txList) {
            // 只处理新添加的文件（status为'ready'）
            if (file.status !== 'ready') return;

            console.log('准备上传文件:', file);
            this.txfileList = []
            this.txfileList = [{
                name: file.name,
                url: file.url,
                uid: file.uid || new Date().getTime(), // 必须有 uid
                status: 'success',
                file
            }]

        },
        async uploadtxImgFile(config, ownerId) {
            //品牌logo
            let img = this.txfileList[0]
            console.log(img);
            const formData = new FormData();
            formData.append('files', img.file.raw || img.file);
            formData.append('matSpecId', this.form3.type);
            formData.append('picType', "brandLogo");
            formData.append('ownerId', ownerId)

            return await axios.post('apis/v3/creative/material/communal/upload',
                formData, config).then(res => {
                    if (res.data.msg != 0) {
                        this.$message({ message: '品牌logo上传失败，问题是：' + res.data.msg, type: 'error' });
                        return
                    }
                    this.txfileCode = [res.data.data.id]
                    console.log(res.data);

                })
        },
        async uploadImgFile(config, ownerId) {
            try {
                const batchSize = 10; // 每批最多10个文件
                const delay = 2000; // 批次间隔2秒
                const totalFiles = this.tpfileList.length;
                const totalBatches = Math.ceil(totalFiles / batchSize);
                const allResults = [];
                let successfulUploads = 0;

                // 显示总进度


                // 分批处理
                for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
                    const start = batchIndex * batchSize;
                    const end = Math.min(start + batchSize, totalFiles);
                    const currentBatch = this.tpfileList.slice(start, end);

                    // 显示当前批次信息
                    this.$message({
                        message: `正在上传第 ${batchIndex + 1}/${totalBatches} 批 (${start + 1}-${end}/${totalFiles})`,
                        type: 'info',
                        duration: 2000
                    });

                    // 创建当前批次的上传Promise数组
                    const batchPromises = currentBatch.map((img, indexInBatch) => {
                        const formData = new FormData();
                        formData.append('files', img.file.raw || img.file);
                        formData.append('matSpecId', this.form3.type);
                        formData.append('picType', "imgs");
                        formData.append('ownerId', ownerId);

                        return axios.post('apis/v3/creative/material/communal/upload', formData, config)
                            .then(res => {
                                if (res.data.msg !== "") {
                                    this.$message({
                                        message: `文件 ${start + indexInBatch + 1} 上传失败: ${res.data.msg}`,
                                        type: 'error',
                                        duration: 3000
                                    });
                                    return {
                                        ...res.data,
                                        error: true,
                                        originalIndex: start + indexInBatch
                                    };
                                }
                                successfulUploads++;
                                return res.data;
                            })
                            .catch(error => {
                                console.error(`文件 ${start + indexInBatch + 1} 上传失败:`, error);
                                this.$message({
                                    message: `文件 ${start + indexInBatch + 1} 上传失败: ${error.message || '网络错误'}`,
                                    type: 'error',
                                    duration: 3000
                                });
                                return {
                                    error: true,
                                    message: error.message,
                                    originalIndex: start + indexInBatch
                                };
                            });
                    });

                    // 等待当前批次完成
                    const batchResults = await Promise.all(batchPromises);
                    allResults.push(...batchResults);

                    // 如果不是最后一批，等待2秒
                    if (batchIndex < totalBatches - 1) {
                        await new Promise(resolve => setTimeout(resolve, delay));
                    }
                }

                console.log('所有上传结果:', allResults);

                // 处理结果
                const successfulResults = allResults.filter(r => !r.error && r.code === 0);
                const failedResults = allResults.filter(r => r.error || r.code !== 0);

                if (failedResults.length > 0) {
                    console.warn('有上传失败的文件:', failedResults);
                    this.$message({
                        message: `上传完成: ${successfulResults.length} 成功, ${failedResults.length} 失败`,
                        type: 'warning',
                        duration: 5000
                    });
                } else {
                    this.$message({
                        message: `所有 ${totalFiles} 个文件上传成功`,
                        type: 'success',
                        duration: 3000
                    });
                }

                // 收集成功的文件ID
                if (successfulResults.length > 0) {
                    const successfulIds = successfulResults
                        .filter(item => item.data && item.data.id)
                        .map(item => item.data.id);

                    this.tpfileListcode = [...this.tpfileListcode, ...successfulIds];

                    // 可选：显示成功上传的数量
                    this.$message({
                        message: `成功上传 ${successfulIds.length} 个文件，已添加到列表`,
                        type: 'success',
                        duration: 3000
                    });
                }

                return {
                    total: totalFiles,
                    successful: successfulResults.length,
                    failed: failedResults.length,
                    results: allResults
                };

            } catch (error) {
                console.error('上传过程中发生错误:', error);
                this.$message({
                    message: `上传失败: ${error.message || '请检查网络或接口'}`,
                    type: 'error',
                    duration: 5000
                });
                throw error; // 重新抛出错误以便外部处理
            }
        },
        async uploadVideoImgFile(config, ownerId) {
            try {
                const batchSize = 10; // 每批最多10个文件
                const delay = 2000; // 批次间隔2秒
                const totalFiles = this.videotpfileList.length;
                console.log(this.videotpfileList);
                if (totalFiles === 0) {
                    this.$message({ message: '没有需要上传的封面图片', type: 'warning' });
                    return [];
                }

                const totalBatches = Math.ceil(totalFiles / batchSize);
                const allResults = [];
                let successfulUploads = 0;

                // 显示开始上传消息
                this.$message({
                    message: `开始上传 ${totalFiles} 个封面图片，共 ${totalBatches} 批`,
                    type: 'info',
                    duration: 3000
                });

                // 分批处理
                for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
                    const start = batchIndex * batchSize;
                    const end = Math.min(start + batchSize, totalFiles);
                    const currentBatch = this.videotpfileList.slice(start, end);

                    // 显示当前批次信息
                    this.$message({
                        message: `正在上传第 ${batchIndex + 1}/${totalBatches} 批封面图片 (${start + 1}-${end}/${totalFiles})`,
                        type: 'info',
                        duration: 2000
                    });

                    // 创建当前批次的上传Promise数组
                    const batchPromises = currentBatch.map((img, indexInBatch) => {
                        const formData = new FormData();
                        console.log(img);
                        if (img.raw) {
                            formData.append('files', img.raw);
                            console.log('使用img.raw');
                        } else if (img.file) {
                            // 如果确实有file属性（虽然你的数据结构显示没有）
                            formData.append('files', img.file.raw || img.file);
                            console.log('使用img.file.raw');
                        } else {
                            // 如果都没有，尝试直接使用img本身
                            formData.append('files', img);
                            console.log('直接使用img对象');
                        }
                        formData.append('matSpecId', this.form3.type);
                        formData.append('picType', "videoImg");
                        formData.append('ownerId', ownerId);

                        return axios.post('apis/v3/creative/material/communal/upload', formData, config)
                            .then(res => {
                                if (res.data.msg !== "") {
                                    this.$message({
                                        message: `封面图片 ${start + indexInBatch + 1} 上传失败: ${res.data.msg}`,
                                        type: 'error',
                                        duration: 3000
                                    });
                                    return {
                                        ...res.data,
                                        error: true,
                                        originalIndex: start + indexInBatch
                                    };
                                }

                                successfulUploads++;
                                return res.data;
                            })
                            .catch(error => {
                                console.error(`封面图片 ${start + indexInBatch + 1} 上传失败:`, error);
                                this.$message({
                                    message: `封面图片 ${start + indexInBatch + 1} 上传失败: ${error.message || '网络错误'}`,
                                    type: 'error',
                                    duration: 3000
                                });
                                return {
                                    error: true,
                                    message: error.message,
                                    originalIndex: start + indexInBatch
                                };
                            });
                    });

                    // 等待当前批次完成
                    const batchResults = await Promise.all(batchPromises);
                    allResults.push(...batchResults);

                    // 如果不是最后一批，等待2秒
                    if (batchIndex < totalBatches - 1) {
                        await new Promise(resolve => setTimeout(resolve, delay));
                    }
                }

                console.log('封面图片所有上传结果:', allResults);

                // 处理结果
                const successfulResults = allResults.filter(r => !r.error && r.code === 0);
                const failedResults = allResults.filter(r => r.error || r.code !== 0);

                if (failedResults.length > 0) {
                    console.warn('有上传失败的封面图片:', failedResults);
                    this.$message({
                        message: `封面图片上传完成: ${successfulResults.length} 成功, ${failedResults.length} 失败`,
                        type: failedResults.length === totalFiles ? 'error' : 'warning',
                        duration: 5000
                    });
                } else {
                    this.$message({
                        message: `所有 ${totalFiles} 个封面图片上传成功`,
                        type: 'success',
                        duration: 3000
                    });
                }

                // 收集成功的文件ID
                if (successfulResults.length > 0) {
                    const successfulIds = successfulResults
                        .filter(item => item.data && item.data.id)
                        .map(item => item.data.id);

                    // 添加到视频封面图片ID列表
                    this.videotpfileListcode = [...this.videotpfileListcode, ...successfulIds];

                    this.$message({
                        message: `成功上传 ${successfulIds.length} 个封面图片，已添加到列表`,
                        type: 'success',
                        duration: 3000
                    });
                }

                return {
                    total: totalFiles,
                    successful: successfulResults.length,
                    failed: failedResults.length,
                    results: allResults
                };

            } catch (error) {
                console.error('封面图片上传过程中发生错误:', error);
                this.$message({
                    message: `封面图片上传失败: ${error.message || '请检查网络或接口'}`,
                    type: 'error',
                    duration: 5000
                });
                throw error;
            }
        },
        async uploadVideoFile(config, ownerId) {
            try {
                const batchSize = 5; // 视频文件较大，每批最多5个文件
                const delay = 3000; // 视频上传时间可能较长，间隔3秒
                const totalFiles = this.videofileList.length;

                if (totalFiles === 0) {
                    this.$message({ message: '没有需要上传的视频文件', type: 'warning' });
                    return [];
                }

                const totalBatches = Math.ceil(totalFiles / batchSize);
                const allResults = [];
                let successfulUploads = 0;

                // 显示开始上传消息
                this.$message({
                    message: `开始上传 ${totalFiles} 个视频文件，共 ${totalBatches} 批`,
                    type: 'info',
                    duration: 4000
                });

                // 分批处理
                for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
                    const start = batchIndex * batchSize;
                    const end = Math.min(start + batchSize, totalFiles);
                    const currentBatch = this.videofileList.slice(start, end);

                    // 显示当前批次信息
                    this.$message({
                        message: `正在上传第 ${batchIndex + 1}/${totalBatches} 批视频文件 (${start + 1}-${end}/${totalFiles})`,
                        type: 'info',
                        duration: 2500
                    });

                    // 创建当前批次的上传Promise数组
                    const batchPromises = currentBatch.map((video, indexInBatch) => {
                        const formData = new FormData();
                        formData.append('files', video.file.raw || video.file);
                        formData.append('matSpecId', this.form3.type);
                        formData.append('ownerId', ownerId);

                        // 添加上传进度监控（可选）
                        const source = axios.CancelToken.source();
                        const configWithProgress = {
                            ...config,
                            cancelToken: source.token,
                            onUploadProgress: (progressEvent) => {
                                const percentCompleted = Math.round(
                                    (progressEvent.loaded * 100) / progressEvent.total
                                );
                                console.log(`视频 ${start + indexInBatch + 1} 上传进度: ${percentCompleted}%`);
                            }
                        };

                        return axios.post('apis/v3/creative/material/communal/upload', formData, configWithProgress)
                            .then(res => {
                                if (res.data.msg !== "") {
                                    this.$message({
                                        message: `视频文件 ${start + indexInBatch + 1} 上传失败: ${res.data.msg}`,
                                        type: 'error',
                                        duration: 4000
                                    });
                                    return {
                                        ...res.data,
                                        error: true,
                                        originalIndex: start + indexInBatch
                                    };
                                }

                                successfulUploads++;
                                this.$message({
                                    message: `视频文件 ${start + indexInBatch + 1} 上传成功`,
                                    type: 'success',
                                    duration: 2000
                                });
                                return res.data;
                            })
                            .catch(error => {
                                if (axios.isCancel(error)) {
                                    console.log(`视频 ${start + indexInBatch + 1} 上传被取消`);
                                    return {
                                        error: true,
                                        message: '上传已取消',
                                        originalIndex: start + indexInBatch
                                    };
                                }

                                console.error(`视频文件 ${start + indexInBatch + 1} 上传失败:`, error);
                                this.$message({
                                    message: `视频文件 ${start + indexInBatch + 1} 上传失败: ${error.message || '网络错误'}`,
                                    type: 'error',
                                    duration: 4000
                                });
                                return {
                                    error: true,
                                    message: error.message,
                                    originalIndex: start + indexInBatch
                                };
                            });
                    });

                    // 等待当前批次完成
                    const batchResults = await Promise.all(batchPromises);
                    allResults.push(...batchResults);

                    // 如果不是最后一批，等待3秒
                    if (batchIndex < totalBatches - 1) {
                        this.$message({
                            message: '等待3秒后继续下一批视频上传...',
                            type: 'info',
                            duration: 2000
                        });
                        await new Promise(resolve => setTimeout(resolve, delay));
                    }
                }

                console.log('所有视频上传结果:', allResults);

                // 处理结果
                const successfulResults = allResults.filter(r => !r.error && r.code === 0);
                const failedResults = allResults.filter(r => r.error || r.code !== 0);

                if (failedResults.length > 0) {
                    console.warn('有上传失败的视频文件:', failedResults);
                    this.$message({
                        message: `视频上传完成: ${successfulResults.length} 成功, ${failedResults.length} 失败`,
                        type: failedResults.length === totalFiles ? 'error' : 'warning',
                        duration: 5000
                    });
                } else {
                    this.$message({
                        message: `所有 ${totalFiles} 个视频文件上传成功`,
                        type: 'success',
                        duration: 3000
                    });
                }

                // 收集成功的视频文件ID
                console.log("收集成功的视频文件ID");
                console.log(successfulResults);


                const itemsWithCover = successfulResults
                    .filter(item => item.data && item.data.id && item.data.coverUrl)
                    .map(item => item.data);


                if (successfulResults.length > 0) {
                    const successfulIds = successfulResults
                        .filter(item => item.data && item.data.id)
                        .map(item => item.data.id);

                    // 添加到视频文件ID列表
                    console.log(this.videofileListcode);
                    console.log(successfulIds);

                    this.videofileListcode = [...this.videofileListcode, ...successfulIds];

                    this.$message({
                        message: `成功上传 ${successfulIds.length} 个视频文件，已添加到列表`,
                        type: 'success',
                        duration: 3000
                    });
                }

                return {
                    total: totalFiles,
                    successful: successfulResults.length,
                    failed: failedResults.length,
                    results: allResults
                };

            } catch (error) {
                console.error('视频上传过程中发生错误:', error);
                this.$message({
                    message: `视频上传失败: ${error.message || '请检查网络或接口'}`,
                    type: 'error',
                    duration: 5000
                });
                throw error;
            }
        },
        async uploadImgFile2(img, item, material_type) {
            console.log(img);
            console.log(item);

            const formData = new FormData();
            formData.append('file', img.file.raw || img.file);

            // 返回 Promise
            return axios.post('/qttupapi/openapi/v1/material/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'OGW_ACCESS_TOKEN': item.utoken
                },
                params: {
                    account_id: item.accountId
                }
            }).then(res => {
                console.log(res.data.data);
                const id = res.data.data.screen ? res.data.data.screen.id : res.data.data.id;

                this.tpfileListcode = [...this.tpfileListcode, id];


                console.log("--------------------------------------------------------");
                // console.log(res.data.data.screen.id);
                console.log("--------------------------------------------------------");
                return res.data; // 返回数据以便后续使用
            }).catch(error => {
                throw error; // 抛出错误以便外部捕获
            });
        },
        async uploadImgFile4(img, item, material_type) {
            console.log(img);
            console.log(item);

            const formData = new FormData();
            formData.append('file', img.file.raw || img.file);

            // 返回 Promise
            return axios.post('/qttupapi/openapi/v1/material/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'OGW_ACCESS_TOKEN': item.utoken
                },
                params: {
                    account_id: item.accountId
                }
            }).then(res => {
                console.log(res.data.data.id);
                this.tpfileListcode = [...this.tpfileListcode, res.data.data.id];
                console.log(this.tpfileListcode);
                console.log("--------------------------------------------------------");
                console.log(res.data.data.id);
                console.log("--------------------------------------------------------");
                return res.data; // 返回数据以便后续使用
            }).catch(error => {
                throw error; // 抛出错误以便外部捕获
            });
        },
        uploadImgFile3(img, item, material_type) {
            console.log(img);
            console.log(item);

            const formData = new FormData();
            formData.append('file', img.file.raw || img.file); // 确保传递的是原始文件对象
            formData.append('material_type', material_type);

            // 返回 Promise
            return axios.post('/qttupapi/openapi/v1/material/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'OGW_ACCESS_TOKEN': item.utoken
                },
                params: {
                    account_id: item.accountId
                }
            }).then(res => {
                console.log(res.data.data.id);
                this.videofileListcode = [...this.videofileListcode, res.data.data.id]
                return res.data; // 返回数据以便后续使用
            }).catch(error => {
                throw error; // 抛出错误以便外部捕获
            });
        },
        onChange(a, fileList) {
            console.log("11111");
            this.txuploadDialogVisible = true
        },
        handlePictureCardPreview: function (file) {
            console.log(file);
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 处理删除
        handleRemove(file) {
            const tp = this.txfileList.findIndex(function (item) {
                return item.uid === file.uid;
            });
            if (tp !== -1) {
                this.txfileList.splice(tp, 1);
            }
            console.log(this.txfileList);
        },
        handleMaterialsdialog() {
            console.log(this.form3.type);
            if(!this.form3.type){
                this.$message.warning('请先选择创意样式');
                return
            }
            this.creativeMaterials = true
        },
        querySearch(queryString, cb) {
            // 过滤出匹配的建议项
            //   const results = queryString ? this.allRestaurants.filter(item => item.value.toLowerCase().includes(queryString.toLowerCase()): this.allRestaurants;
            const results = queryString ? this.allRestaurants.filter(item => item.value.toLowerCase().includes(queryString.toLowerCase())) : this.allRestaurants;
            // 调用回调函数返回建议列表
            cb(results)
        },
        ocpcTypechange(type){
            console.log(type);
            if(type==8){
                this.form2.deepOcpcTypeoptions=[{ value: "10", label: "回传留存" },
                { value: "39", label: "回传留存率" },]
            }
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        CreativeTypechang() {
            console.log(this.selectedStyle);
            this.form3.type = this.selectedStyle
            this.createTypedialog = false
        },
        selectStyle(style) {
            console.log(style);
            this.selectedStyle = style.value
            console.log(style.value);
            console.log('style.value:', style.value, 'type:', typeof style.value);
            let materialType;

            switch (Number(style.value)) {
                case 63:
                    materialType = '竖版视频';
                    break;
                case 60:
                    materialType = '横版视频';
                    break;

                case 20:
                    materialType = '横版小图';
                    break;

                case 1:
                    materialType = '横版大图';
                    break;

                case 50:
                    materialType = '竖版大图';

                    break;

                case 30:
                    materialType = '横版组图';
                    break;
                case 71:
                    materialType = '图标大图';
                    break;

                case 5:
                    materialType = '开屏横图';
                    break;
                case 34:
                    materialType = '开屏竖图';
                    break;

                default:
                    throw new Error(`未知的广告类型: ${style.value}`);
            }
            console.log(materialType);
            this.material_type = materialType
            this.selectedStylelabel = style.label
        },
        handleStyleChange(value) {
            this.$emit('change', value);
        },

        // 打开样式选择对话框（示例）
        openStyleDialog() {
            this.createTypedialog = true
        },
        handleinterestChange() {

        },
        handleTimeLimitChange() {
            if (this.timeLimit === 0) {
                // 如果选择不限制，清空已选择的时间
                this.clearTimeSettings();
            }
        },
        clearTimeSettings() {
            this.startTime = null;
            this.endTime = null;
            this.errorMessage = "";
            this.timeSet = "";
        },
        validateAndGenerateTimeSet() {
            // 只有当开始时间和结束时间都存在时，才进行校验和生成
            if (this.startTime && this.endTime) {
                if (this.startTime >= this.endTime) {
                    this.errorMessage = "开始时间不能大于或等于结束时间";
                    this.timeSet = ""; // 清空错误情况下的timeSet
                } else {
                    this.errorMessage = "";
                    this.generateTimeSet(); // 生成JSON
                }
            }
        },
        convertTimeToHalfHours(time) {
            const [hour, minute] = time.split(':').map(Number);
            // 一小时内有2个半小时段，分钟为30时表示该半小时的结束段
            return hour * 2 + (minute === 30 ? 1 : 0);
        },
        generateTimeSet() {
            // 将开始时间和结束时间转化为半小时的编号
            const startHalfHour = this.convertTimeToHalfHours(this.startTime);
            const endHalfHour = this.convertTimeToHalfHours(this.endTime) - 1; // 结束时间不包括最后的半小时

            // 构建每一天的时间段，转换为以半小时为单位的数组
            let timeSetObj = {};
            const halfHourArray = [];
            for (let i = startHalfHour; i <= endHalfHour; i++) {
                halfHourArray.push(i);
            }
            const halfHourString = halfHourArray.join(',');

            // 为每一天构建相同的时间段
            this.days.forEach(day => {
                timeSetObj[day] = halfHourString;
            });

            // 将 JSON 对象转为字符串并显示
            this.timeSet = JSON.stringify(timeSetObj);
        },











    },

};
</script>

<style scoped>
.ad-flow {
    position: fixed;
    height: 450px;
    top: 150px;
    /* left: 0; */
    right: 150px;
    padding: 15px 0;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.el-step__title {
    font-size: 14px;
}

.select-container {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
}

.plan-container {
    text-align: left;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 50px;
}

.el-form-item__label {
    margin-right: 50px;
}

.demo-ruleForm {
    max-width: 800px;
}

.el-form-item {
    margin-bottom: 22px;
}

.el-radio-group {
    margin-right: 15px;
}

.el-input {
    width: 280px;
}

.el-icon-info {
    color: #409EFF;
    cursor: pointer;
    font-size: 16px;
}

.el-button {
    margin-right: 10px;
}

.adgroup-container {
    padding: 20px;
    background-color: #fff;
}

.adgroup-form {
    max-width: 1200px;
    margin: 0 auto;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 10px;
    /* border-bottom: 1px solid #eee; */
}

.form-tip {
    font-size: 12px;
    color: #999;
    margin-top: 8px;
}

.media-specify-box,
.adslot-specify-box,
.region-custom-box,
.time-custom-box {
    margin-top: 15px;
    padding: 15px;
    background-color: #f9f9f9;
    border-radius: 4px;
}

.region-selection {
    margin-top: 15px;
    max-height: 300px;
    overflow-y: auto;
}

.region-item {
    margin-bottom: 10px;
}

.age-checkbox-group,
.phone-price-group,
.network-group {
    display: inline-block;
    margin-left: 15px;
}

.orientBtn {
    margin-right: 10px;
}

.orientBtnActive {
    background-color: #409EFF;
    color: #fff;
}

.time-grid {
    margin-top: 15px;
    border: 1px solid #eee;
}

.time-grid-header {
    display: flex;
    border-bottom: 1px solid #eee;
    background-color: #f5f7fa;
}

.time-grid-header>div:first-child {
    width: 80px;
    padding: 10px;
    text-align: center;
}

.time-slots {
    display: flex;
    flex: 1;
}

.time-slots span {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-size: 12px;
}

.time-grid-body {
    display: flex;
    flex-direction: column;
}

.time-row {
    display: flex;
    border-bottom: 1px solid #eee;
}

.time-row:last-child {
    border-bottom: none;
}

.day-label {
    width: 80px;
    padding: 10px;
    text-align: center;
    background-color: #f5f7fa;
}

.time-cells {
    display: flex;
    flex: 1;
}

.time-cell {
    flex: 1;
    height: 40px;
    border-right: 1px solid #eee;
    cursor: pointer;
}

.time-cell:last-child {
    border-right: none;
}

.time-cell.active {
    background-color: #409EFF;
}

.form-actions {
    margin-top: 30px;
    text-align: center;
}

.form-actions .el-button {
    margin: 0 10px;
}

.adgroup-item {
    color: #1890ff;
    line-height: 20px;
    font-size: 16px;
    border-left: 2px solid #1890ff;
    padding-left: 8px;
    font-family: PingFangSC-Regular;
    margin-top: 40px;
    margin-bottom: 40px;
}

.adgroup-item2 {
    color: #606266;
    line-height: 20px;
    font-size: 12px;
    border-left: 2px solid #606266;
    padding-left: 8px;
    font-family: PingFangSC-Regular;
    margin-top: 40px;
    margin-bottom: 40px;
}

.demo-ruleForm {
    max-width: 1000px;
}

.time-custom-box {
    margin-top: 15px;
    padding: 15px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background-color: #f5f7fa;
}

.time-grid {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 15px;
}

.time-grid-header {
    display: flex;
    background-color: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
}

.header-label {
    width: 120px;
    padding: 10px;
    text-align: center;
    font-weight: bold;
}

.time-slots {
    flex: 1;
    display: flex;
}

.time-slots span {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-size: 12px;
}

.time-grid-body {
    background-color: #fff;
}

.time-row {
    display: flex;
    border-bottom: 1px solid #ebeef5;
}

.time-row:last-child {
    border-bottom: none;
}

.day-label {
    width: 120px;
    padding: 10px;
    display: flex;
    align-items: center;
    border-right: 1px solid #ebeef5;
}

.day-label>>>.el-checkbox {
    width: 100%;
}

.time-cells {
    flex: 1;
    display: flex;
}

.time-cell {
    flex: 1;
    height: 40px;
    border-right: 1px solid #ebeef5;
    cursor: pointer;
}

.time-cell:last-child {
    border-right: none;
}

.time-cell:hover:not(.disabled) {
    background-color: #ecf5ff;
}

.time-cell.active:not(.disabled) {
    background-color: #409eff;
}

.time-cell.disabled {
    background-color: #f5f7fa;
    cursor: not-allowed;
}

.selected-times {
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.selected-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background-color: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
}

.selected-content {
    padding: 15px;
    background-color: #fff;
}

.selected-content div {
    margin-bottom: 5px;
    font-size: 14px;
}

.selected-content div:last-child {
    margin-bottom: 0;
}

.creative-item.idea-select {
    margin-bottom: 22px;
}

/* 成功状态样式 */
.creative-item.is-success .el-input__inner {
    border-color: #67c23a;
}

/* 必填项红色星号 */
.creative-item.is-required .el-form-item__label::before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
}

.creative-item.idea-select {
    margin-bottom: 22px;
}

.style-selector {
    width: 100%;
}

.category {
    margin-bottom: 20px;
}

.category-title {
    font-size: 14px;
    color: #606266;
    margin-bottom: 10px;
    font-weight: bold;
}

.style-list {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0 -8px;
}

.style-list li {
    width: 20%;
    padding: 15px 8px;
    margin-left: 15px;
    margin-bottom: 16px;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid #e6e7eb;
}

.style-list li.selected {
    border: 1px solid #409eff;
    border-radius: 4px;
}

.style-list li.recommended {
    position: relative;
}

.style-image {}

.style-image img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.style-info {
    display: block;
    margin-top: 8px;
    text-align: center;
    font-size: 12px;
    color: #606266;
}

.selected-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
}

.style-tips {
    margin-top: 10px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    font-size: 12px;
    color: #606266;
}

.bg-image {
    width: 48px;
    height: 48px;
}

.video-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin: 0 -8px;
}

.video-item {
    flex: 0 0 calc(25% - 12px);
    /* 一行 4 个，减掉间距 */
    box-sizing: border-box;
}

.video-content {
    position: relative;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 12px;
    transition: all 0.3s;
}

.video-content:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.video-title {
    width: 70%;
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.video-thumbnail {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    /* 16:9 比例 */
    position: relative;
    overflow: hidden;
    background: #f5f7fa;
}

.video-thumbnail video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.delete-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    color: #f56c6c;
}

.adgroup-container {
    position: relative;
    min-height: 100vh;
    padding-bottom: 80px;
    /* 给底部栏留出空间 */
}

.adgroup-main {
    padding: 20px;
    /* 主要内容样式 */
}

.adgroup-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px 0;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .adgroup-footer {
        flex-direction: column;
        padding: 10px;
    }

    .adgroup-footer .el-button {
        margin: 5px 0 !important;
        width: 100%;
    }
}

.custom-steps ::v-deep .el-step__head.is-success {
    /* 隐藏成功状态的图标 */
    display: none;
}

.custom-steps ::v-deep .el-step__title.is-success {
    /* 设置成功状态的文字颜色为蓝色 */
    color: #1890ff;
    font-weight: 500;
}

/* 可选：调整步骤条的布局，因为隐藏了图标 */
.custom-steps ::v-deep .el-step__main {
    margin-left: 0;
    padding-left: 0;
}

.custom-steps ::v-deep .el-step__line {
    /* 调整连接线的位置 */
    left: 8px;
}

.image-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 12px 16px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 8px;
    color: white;
}

.image-count {
    font-size: 14px;
    font-weight: 500;
}

.image-count i {
    margin-right: 8px;
}

.message-content {
    word-break: break-all;
    line-height: 1.4;
}

/* 单行省略号 */
.single-line-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 多行省略号（显示3行） */
.multi-line-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 4.2em;
    /* 3行高度  */
}

.status-success {
    color: #67c23a;
    font-weight: bold;
}

.status-error {
    color: #f56c6c;
    font-weight: bold;
}

.status-wait {
    color: #909399;
    font-weight: bold;
}

.auto-cover-option {
    margin: 10px 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.auto-cover-option .el-checkbox {
    margin-right: 5px;
}

.auto-cover-option .el-icon-question {
    color: #909399;
    cursor: help;
}

.el-checkbox__label {
    color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/oppo/oppopida.vue